;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="c5505994-f5fa-49ba-a068-b4887f4547b8",e._sentryDebugIdIdentifier="sentry-dbid-c5505994-f5fa-49ba-a068-b4887f4547b8")}catch(e){}}();
"use strict";
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[712],{

/***/ 9919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ BackendEnums)
/* harmony export */ });
/* eslint-disable no-shadow */
let BackendEnums;
(function (_BackendEnums) {
  let ActionTypeEnum = /*#__PURE__*/function (ActionTypeEnum) {
    ActionTypeEnum["SEND_RATING_EMAIL"] = "SEND_RATING_EMAIL";
    ActionTypeEnum["SEND_MESSAGE_TEMPLATE"] = "SEND_MESSAGE_TEMPLATE";
    ActionTypeEnum["SEND_SMS"] = "SEND_SMS";
    ActionTypeEnum["ADD_DEADLINE"] = "ADD_DEADLINE";
    ActionTypeEnum["ASSIGN_AGENT"] = "ASSIGN_AGENT";
    ActionTypeEnum["UNASSIGN_AGENT"] = "UNASSIGN_AGENT";
    ActionTypeEnum["ADD_DOCUMENT"] = "ADD_DOCUMENT";
    ActionTypeEnum["ADD_TRANSPORT"] = "ADD_TRANSPORT";
    ActionTypeEnum["ADD_TAG"] = "ADD_TAG";
    ActionTypeEnum["REMOVE_TAG"] = "REMOVE_TAG";
    ActionTypeEnum["CLOSE_TICKET"] = "CLOSE_TICKET";
    ActionTypeEnum["REOPEN_TICKET"] = "REOPEN_TICKET";
    ActionTypeEnum["CHANGE_STATE"] = "CHANGE_STATE";
    ActionTypeEnum["ORDER_REQUESTED_SHIPPING"] = "ORDER_REQUESTED_SHIPPING";
    ActionTypeEnum["ADD_ACTIVITY"] = "ADD_ACTIVITY";
    ActionTypeEnum["FILL_CUSTOM_FIELD"] = "FILL_CUSTOM_FIELD";
    return ActionTypeEnum;
  }({});
  _BackendEnums.ActionTypeEnum = ActionTypeEnum;
  let ActivityStatusEnum = /*#__PURE__*/function (ActivityStatusEnum) {
    ActivityStatusEnum["STATUS_OPEN"] = "STATUS_OPEN";
    ActivityStatusEnum["STATUS_CLOSED"] = "STATUS_CLOSED";
    return ActivityStatusEnum;
  }({});
  _BackendEnums.ActivityStatusEnum = ActivityStatusEnum;
  let BilledInvoiceStatusEnum = /*#__PURE__*/function (BilledInvoiceStatusEnum) {
    BilledInvoiceStatusEnum["DRAFT"] = "DRAFT";
    BilledInvoiceStatusEnum["FINALIZED"] = "FINALIZED";
    BilledInvoiceStatusEnum["AWAITING_PAYMENT"] = "AWAITING_PAYMENT";
    BilledInvoiceStatusEnum["REQUIRES_ACTION"] = "REQUIRES_ACTION";
    BilledInvoiceStatusEnum["RETRYING"] = "RETRYING";
    BilledInvoiceStatusEnum["PAID"] = "PAID";
    BilledInvoiceStatusEnum["UNCOLLECTIBLE"] = "UNCOLLECTIBLE";
    BilledInvoiceStatusEnum["REFUNDED"] = "REFUNDED";
    BilledInvoiceStatusEnum["VOIDED"] = "VOIDED";
    BilledInvoiceStatusEnum["FAIL"] = "FAIL";
    return BilledInvoiceStatusEnum;
  }({});
  _BackendEnums.BilledInvoiceStatusEnum = BilledInvoiceStatusEnum;
  let BillingCurrencyEnum = /*#__PURE__*/function (BillingCurrencyEnum) {
    BillingCurrencyEnum["CZK"] = "CZK";
    BillingCurrencyEnum["EUR"] = "EUR";
    return BillingCurrencyEnum;
  }({});
  _BackendEnums.BillingCurrencyEnum = BillingCurrencyEnum;
  let BillingSchemeEnum = /*#__PURE__*/function (BillingSchemeEnum) {
    BillingSchemeEnum["PER_UNIT"] = "PER_UNIT";
    BillingSchemeEnum["TIERED"] = "TIERED";
    BillingSchemeEnum["EXTERNAL"] = "EXTERNAL";
    return BillingSchemeEnum;
  }({});
  _BackendEnums.BillingSchemeEnum = BillingSchemeEnum;
  let BulkActionActionEnum = /*#__PURE__*/function (BulkActionActionEnum) {
    BulkActionActionEnum["CLOSE"] = "close";
    BulkActionActionEnum["DELETE"] = "delete";
    BulkActionActionEnum["ASSIGN"] = "assign";
    BulkActionActionEnum["STATE_CHANGE"] = "state_change";
    BulkActionActionEnum["ADD_TAGS"] = "add_tags";
    BulkActionActionEnum["REMOVE_TAGS"] = "remove_tags";
    BulkActionActionEnum["EXPORT_TICKETS"] = "export_tickets";
    BulkActionActionEnum["EXPORT_PRODUCTS"] = "export_products";
    BulkActionActionEnum["EXPORT_PDF"] = "export_pdf";
    return BulkActionActionEnum;
  }({});
  _BackendEnums.BulkActionActionEnum = BulkActionActionEnum;
  let BulkActionStatusEnum = /*#__PURE__*/function (BulkActionStatusEnum) {
    BulkActionStatusEnum["PENDING"] = "pending";
    BulkActionStatusEnum["COMPLETED"] = "completed";
    BulkActionStatusEnum["FAILED"] = "failed";
    return BulkActionStatusEnum;
  }({});
  _BackendEnums.BulkActionStatusEnum = BulkActionStatusEnum;
  let ButtonRadiusEnum = /*#__PURE__*/function (ButtonRadiusEnum) {
    ButtonRadiusEnum["NONE"] = "none";
    ButtonRadiusEnum["SM"] = "sm";
    ButtonRadiusEnum["MD"] = "md";
    ButtonRadiusEnum["LG"] = "lg";
    ButtonRadiusEnum["FULL"] = "full";
    return ButtonRadiusEnum;
  }({});
  _BackendEnums.ButtonRadiusEnum = ButtonRadiusEnum;
  let CardProviderEnum = /*#__PURE__*/function (CardProviderEnum) {
    CardProviderEnum["STRIPE"] = "STRIPE";
    return CardProviderEnum;
  }({});
  _BackendEnums.CardProviderEnum = CardProviderEnum;
  let CompanyEmailSettingTypeEnum = /*#__PURE__*/function (CompanyEmailSettingTypeEnum) {
    CompanyEmailSettingTypeEnum["TYPE_TRANSPORT_LABEL"] = "TYPE_TRANSPORT_LABEL";
    CompanyEmailSettingTypeEnum["TYPE_TICKET_CREATED"] = "TYPE_TICKET_CREATED";
    CompanyEmailSettingTypeEnum["TYPE_RATING"] = "TYPE_RATING";
    CompanyEmailSettingTypeEnum["TYPE_DOCUMENT"] = "TYPE_DOCUMENT";
    CompanyEmailSettingTypeEnum["TYPE_CREDIT_NOTE"] = "TYPE_CREDIT_NOTE";
    CompanyEmailSettingTypeEnum["TYPE_VOUCHER"] = "TYPE_VOUCHER";
    return CompanyEmailSettingTypeEnum;
  }({});
  _BackendEnums.CompanyEmailSettingTypeEnum = CompanyEmailSettingTypeEnum;
  let CompanyOnboardingStepTypeEnum = /*#__PURE__*/function (CompanyOnboardingStepTypeEnum) {
    CompanyOnboardingStepTypeEnum["BASE_SETTINGS"] = "BASE_SETTINGS";
    CompanyOnboardingStepTypeEnum["DATA_INTEGRATION"] = "DATA_INTEGRATION";
    CompanyOnboardingStepTypeEnum["WIDGET_INTEGRATION"] = "WIDGET_INTEGRATION";
    CompanyOnboardingStepTypeEnum["SHIPPING_SETTINGS"] = "SHIPPING_SETTINGS";
    CompanyOnboardingStepTypeEnum["PORTAL_INTEGRATION"] = "PORTAL_INTEGRATION";
    CompanyOnboardingStepTypeEnum["PORTAL_FIRST_TICKET"] = "PORTAL_FIRST_TICKET";
    CompanyOnboardingStepTypeEnum["TRACKING_SELECT_LANGUAGES"] = "TRACKING_SELECT_LANGUAGES";
    CompanyOnboardingStepTypeEnum["TRACKING_ORDER_INTEGRATION"] = "TRACKING_ORDER_INTEGRATION";
    CompanyOnboardingStepTypeEnum["TRACKING_CARRIER_SELECTION"] = "TRACKING_CARRIER_SELECTION";
    CompanyOnboardingStepTypeEnum["TRACKING_BRAND_IDENTITY"] = "TRACKING_BRAND_IDENTITY";
    return CompanyOnboardingStepTypeEnum;
  }({});
  _BackendEnums.CompanyOnboardingStepTypeEnum = CompanyOnboardingStepTypeEnum;
  let CompanyOrderProviderProviderEnum = /*#__PURE__*/function (CompanyOrderProviderProviderEnum) {
    CompanyOrderProviderProviderEnum["SHOPTET_API"] = "SHOPTET_API";
    CompanyOrderProviderProviderEnum["RETINO_XML"] = "RETINO_XML";
    CompanyOrderProviderProviderEnum["PRESTASHOP_16"] = "PRESTASHOP_16";
    CompanyOrderProviderProviderEnum["UPGATES_API"] = "UPGATES_API";
    CompanyOrderProviderProviderEnum["SHOPIFY_PRIVATE"] = "SHOPIFY_PRIVATE";
    CompanyOrderProviderProviderEnum["SHOPIFY_API"] = "SHOPIFY_API";
    CompanyOrderProviderProviderEnum["SIMPLIA_API"] = "SIMPLIA_API";
    CompanyOrderProviderProviderEnum["SHOPRENTER_API"] = "SHOPRENTER_API";
    CompanyOrderProviderProviderEnum["WEBAREAL_API"] = "WEBAREAL_API";
    CompanyOrderProviderProviderEnum["SHOPWARE_5"] = "SHOPWARE_5";
    CompanyOrderProviderProviderEnum["SHOPWARE_6"] = "SHOPWARE_6";
    CompanyOrderProviderProviderEnum["BYZNYSWEB_API"] = "BYZNYSWEB_API";
    CompanyOrderProviderProviderEnum["WOOCOMMERCE_API"] = "WOOCOMMERCE_API";
    CompanyOrderProviderProviderEnum["RETINO_ORDERS_API"] = "RETINO_ORDERS_API";
    return CompanyOrderProviderProviderEnum;
  }({});
  _BackendEnums.CompanyOrderProviderProviderEnum = CompanyOrderProviderProviderEnum;
  let CompanyOrderProviderStateEnum = /*#__PURE__*/function (CompanyOrderProviderStateEnum) {
    CompanyOrderProviderStateEnum["READY"] = "READY";
    CompanyOrderProviderStateEnum["INIT"] = "INIT";
    CompanyOrderProviderStateEnum["FAILED"] = "FAILED";
    CompanyOrderProviderStateEnum["DISABLED"] = "DISABLED";
    CompanyOrderProviderStateEnum["STOPPED"] = "STOPPED";
    return CompanyOrderProviderStateEnum;
  }({});
  _BackendEnums.CompanyOrderProviderStateEnum = CompanyOrderProviderStateEnum;
  let ConditionOperationEnum = /*#__PURE__*/function (ConditionOperationEnum) {
    ConditionOperationEnum["AND"] = "AND";
    ConditionOperationEnum["OR"] = "OR";
    return ConditionOperationEnum;
  }({});
  _BackendEnums.ConditionOperationEnum = ConditionOperationEnum;
  let CountryEnum = /*#__PURE__*/function (CountryEnum) {
    CountryEnum["AU"] = "AU";
    CountryEnum["AT"] = "AT";
    CountryEnum["BY"] = "BY";
    CountryEnum["BE"] = "BE";
    CountryEnum["BA"] = "BA";
    CountryEnum["BG"] = "BG";
    CountryEnum["CA"] = "CA";
    CountryEnum["HR"] = "HR";
    CountryEnum["CY"] = "CY";
    CountryEnum["CZ"] = "CZ";
    CountryEnum["DK"] = "DK";
    CountryEnum["EE"] = "EE";
    CountryEnum["FI"] = "FI";
    CountryEnum["FR"] = "FR";
    CountryEnum["DE"] = "DE";
    CountryEnum["GR"] = "GR";
    CountryEnum["GL"] = "GL";
    CountryEnum["HU"] = "HU";
    CountryEnum["IS"] = "IS";
    CountryEnum["IN"] = "IN";
    CountryEnum["IE"] = "IE";
    CountryEnum["IT"] = "IT";
    CountryEnum["LV"] = "LV";
    CountryEnum["LI"] = "LI";
    CountryEnum["LT"] = "LT";
    CountryEnum["LU"] = "LU";
    CountryEnum["MK"] = "MK";
    CountryEnum["MT"] = "MT";
    CountryEnum["MD"] = "MD";
    CountryEnum["MC"] = "MC";
    CountryEnum["ME"] = "ME";
    CountryEnum["NL"] = "NL";
    CountryEnum["NO"] = "NO";
    CountryEnum["PL"] = "PL";
    CountryEnum["PT"] = "PT";
    CountryEnum["QA"] = "QA";
    CountryEnum["RO"] = "RO";
    CountryEnum["RU"] = "RU";
    CountryEnum["SA"] = "SA";
    CountryEnum["RS"] = "RS";
    CountryEnum["SK"] = "SK";
    CountryEnum["SI"] = "SI";
    CountryEnum["ZA"] = "ZA";
    CountryEnum["ES"] = "ES";
    CountryEnum["SE"] = "SE";
    CountryEnum["CH"] = "CH";
    CountryEnum["TW"] = "TW";
    CountryEnum["TR"] = "TR";
    CountryEnum["UA"] = "UA";
    CountryEnum["AE"] = "AE";
    CountryEnum["GB"] = "GB";
    CountryEnum["US"] = "US";
    CountryEnum["VN"] = "VN";
    return CountryEnum;
  }({});
  _BackendEnums.CountryEnum = CountryEnum;
  let CreditNoteStatusEnum = /*#__PURE__*/function (CreditNoteStatusEnum) {
    CreditNoteStatusEnum["NEW"] = "NEW";
    CreditNoteStatusEnum["SYNCED"] = "SYNCED";
    CreditNoteStatusEnum["FAILED"] = "FAILED";
    return CreditNoteStatusEnum;
  }({});
  _BackendEnums.CreditNoteStatusEnum = CreditNoteStatusEnum;
  let CreditNoteVariableSymbolSourceEnum = /*#__PURE__*/function (CreditNoteVariableSymbolSourceEnum) {
    CreditNoteVariableSymbolSourceEnum["TICKET_CODE"] = "TICKET_CODE";
    CreditNoteVariableSymbolSourceEnum["ORDER_CODE"] = "ORDER_CODE";
    CreditNoteVariableSymbolSourceEnum["ORDER_REMOTE_ID"] = "ORDER_REMOTE_ID";
    return CreditNoteVariableSymbolSourceEnum;
  }({});
  _BackendEnums.CreditNoteVariableSymbolSourceEnum = CreditNoteVariableSymbolSourceEnum;
  let CurrencyEnum = /*#__PURE__*/function (CurrencyEnum) {
    CurrencyEnum["AUD"] = "AUD";
    CurrencyEnum["BGN"] = "BGN";
    CurrencyEnum["CAD"] = "CAD";
    CurrencyEnum["CHF"] = "CHF";
    CurrencyEnum["CZK"] = "CZK";
    CurrencyEnum["DKK"] = "DKK";
    CurrencyEnum["EUR"] = "EUR";
    CurrencyEnum["GBP"] = "GBP";
    CurrencyEnum["HRK"] = "HRK";
    CurrencyEnum["HUF"] = "HUF";
    CurrencyEnum["ILS"] = "ILS";
    CurrencyEnum["JPY"] = "JPY";
    CurrencyEnum["MXN"] = "MXN";
    CurrencyEnum["NOK"] = "NOK";
    CurrencyEnum["PLN"] = "PLN";
    CurrencyEnum["RON"] = "RON";
    CurrencyEnum["SEK"] = "SEK";
    CurrencyEnum["SGD"] = "SGD";
    CurrencyEnum["THB"] = "THB";
    CurrencyEnum["UAH"] = "UAH";
    CurrencyEnum["USD"] = "USD";
    return CurrencyEnum;
  }({});
  _BackendEnums.CurrencyEnum = CurrencyEnum;
  let CustomFieldTypeEnum = /*#__PURE__*/function (CustomFieldTypeEnum) {
    CustomFieldTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    CustomFieldTypeEnum["CHAR"] = "CHAR";
    CustomFieldTypeEnum["DATE"] = "DATE";
    CustomFieldTypeEnum["MULTILINE"] = "MULTILINE";
    CustomFieldTypeEnum["NUMERIC"] = "NUMERIC";
    CustomFieldTypeEnum["BOOL"] = "BOOL";
    CustomFieldTypeEnum["SELECT"] = "SELECT";
    CustomFieldTypeEnum["SELECTMULTI"] = "SELECTMULTI";
    CustomFieldTypeEnum["URL"] = "URL";
    CustomFieldTypeEnum["FILE"] = "FILE";
    CustomFieldTypeEnum["CZECH_BANK_ACCOUNT"] = "CZECH_BANK_ACCOUNT";
    CustomFieldTypeEnum["IBAN"] = "IBAN";
    return CustomFieldTypeEnum;
  }({});
  _BackendEnums.CustomFieldTypeEnum = CustomFieldTypeEnum;
  let CustomRefundExportFieldsEnum = /*#__PURE__*/function (CustomRefundExportFieldsEnum) {
    CustomRefundExportFieldsEnum["RECIPIENT_NAME"] = "recipient_name";
    CustomRefundExportFieldsEnum["TICKET__CODE"] = "ticket__code";
    CustomRefundExportFieldsEnum["VALUE"] = "value";
    CustomRefundExportFieldsEnum["CURRENCY"] = "currency";
    CustomRefundExportFieldsEnum["VALID_UNTIL"] = "valid_until";
    CustomRefundExportFieldsEnum["MESSAGE"] = "message";
    CustomRefundExportFieldsEnum["TICKET__TYPE__NAME"] = "ticket__type__name";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__CODE"] = "ticket__bound_order__code";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__CUSTOMER_EMAIL"] = "ticket__bound_order__customer_email";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__CUSTOMER_PHONE"] = "ticket__bound_order__customer_phone";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__TRACKING_NUMBER"] = "ticket__bound_order__tracking_number";
    CustomRefundExportFieldsEnum["ANNOTATED_BANK_ACCOUNT"] = "annotated_bank_account";
    return CustomRefundExportFieldsEnum;
  }({});
  _BackendEnums.CustomRefundExportFieldsEnum = CustomRefundExportFieldsEnum;
  let DataRetentionPolicyEnum = /*#__PURE__*/function (DataRetentionPolicyEnum) {
    DataRetentionPolicyEnum["PRIVATE_DATA"] = "private_data";
    DataRetentionPolicyEnum["ALL_DATA"] = "all_data";
    return DataRetentionPolicyEnum;
  }({});
  _BackendEnums.DataRetentionPolicyEnum = DataRetentionPolicyEnum;
  let DropOffBranchShippingProvidersEnum = /*#__PURE__*/function (DropOffBranchShippingProvidersEnum) {
    DropOffBranchShippingProvidersEnum["ZASILKOVNA"] = "ZASILKOVNA";
    DropOffBranchShippingProvidersEnum["MY_GLS_DROPOFF"] = "MY_GLS_DROPOFF";
    DropOffBranchShippingProvidersEnum["DPD_DROPOFF"] = "DPD_DROPOFF";
    DropOffBranchShippingProvidersEnum["RETINO_PPL"] = "RETINO_PPL";
    DropOffBranchShippingProvidersEnum["CUSTOMER_RETINO_PPL"] = "CUSTOMER_RETINO_PPL";
    DropOffBranchShippingProvidersEnum["CUSTOMER_RETINO_GLS_DROPOFF"] = "CUSTOMER_RETINO_GLS_DROPOFF";
    DropOffBranchShippingProvidersEnum["LIFTAGO_RETINO_PPL"] = "LIFTAGO_RETINO_PPL";
    DropOffBranchShippingProvidersEnum["GLS_DROPOFF_PL"] = "GLS_DROPOFF_PL";
    DropOffBranchShippingProvidersEnum["RETURN_CONNECT"] = "RETURN_CONNECT";
    DropOffBranchShippingProvidersEnum["DHL_DROPOFF"] = "DHL_DROPOFF";
    return DropOffBranchShippingProvidersEnum;
  }({});
  _BackendEnums.DropOffBranchShippingProvidersEnum = DropOffBranchShippingProvidersEnum;
  let EqualityEnum = /*#__PURE__*/function (EqualityEnum) {
    EqualityEnum["EQUALS_TO"] = "EQUALS_TO";
    EqualityEnum["NOT_EQUALS_TO"] = "NOT_EQUALS_TO";
    EqualityEnum["GREATER_THAN"] = "GREATER_THAN";
    EqualityEnum["LESS_THAN"] = "LESS_THAN";
    EqualityEnum["GREATER_THAN_OR_EQUAL_TO"] = "GREATER_THAN_OR_EQUAL_TO";
    EqualityEnum["LESS_THAN_OR_EQUAL_TO"] = "LESS_THAN_OR_EQUAL_TO";
    EqualityEnum["EARLIER_THAN"] = "EARLIER_THAN";
    EqualityEnum["NOT_EARLIER_THAN"] = "NOT_EARLIER_THAN";
    EqualityEnum["EMPTY_FIELD"] = "EMPTY_FIELD";
    return EqualityEnum;
  }({});
  _BackendEnums.EqualityEnum = EqualityEnum;
  let EventEnum = /*#__PURE__*/function (EventEnum) {
    EventEnum["TICKET.CREATED"] = "ticket.created";
    EventEnum["TICKET.UPDATED"] = "ticket.updated";
    EventEnum["TICKET.PRODUCT.CREATED"] = "ticket.product.created";
    EventEnum["TICKET.PRODUCT.UPDATED"] = "ticket.product.updated";
    EventEnum["TICKET.SHIPPING.CREATED"] = "ticket.shipping.created";
    EventEnum["TICKET.SHIPPING.UPDATED"] = "ticket.shipping.updated";
    EventEnum["TICKET.REFUND.CREATED"] = "ticket.refund.created";
    EventEnum["TICKET.REFUND.UPDATED"] = "ticket.refund.updated";
    EventEnum["RETINO_CREDIT_NOTE.CREATED"] = "retino_credit_note.created";
    EventEnum["RETINO_REFUND.CREATED"] = "retino_refund.created";
    EventEnum["SHIPPING.ORDERED"] = "shipping.ordered";
    return EventEnum;
  }({});
  _BackendEnums.EventEnum = EventEnum;
  let EventsEnum = /*#__PURE__*/function (EventsEnum) {
    EventsEnum["TICKET.CREATED"] = "ticket.created";
    EventsEnum["TICKET.UPDATED"] = "ticket.updated";
    EventsEnum["TICKET.PRODUCT.CREATED"] = "ticket.product.created";
    EventsEnum["TICKET.PRODUCT.UPDATED"] = "ticket.product.updated";
    EventsEnum["TICKET.SHIPPING.CREATED"] = "ticket.shipping.created";
    EventsEnum["TICKET.SHIPPING.UPDATED"] = "ticket.shipping.updated";
    EventsEnum["TICKET.REFUND.CREATED"] = "ticket.refund.created";
    EventsEnum["TICKET.REFUND.UPDATED"] = "ticket.refund.updated";
    EventsEnum["RETINO_CREDIT_NOTE.CREATED"] = "retino_credit_note.created";
    EventsEnum["RETINO_REFUND.CREATED"] = "retino_refund.created";
    EventsEnum["SHIPPING.ORDERED"] = "shipping.ordered";
    return EventsEnum;
  }({});
  _BackendEnums.EventsEnum = EventsEnum;
  let ExternalStatusEnum = /*#__PURE__*/function (ExternalStatusEnum) {
    ExternalStatusEnum["STATUS_ORDERED"] = "STATUS_ORDERED";
    ExternalStatusEnum["STATUS_IN_TRANSIT"] = "STATUS_IN_TRANSIT";
    ExternalStatusEnum["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    ExternalStatusEnum["STATUS_UNDELIVERED"] = "STATUS_UNDELIVERED";
    ExternalStatusEnum["STATUS_CANCELED"] = "STATUS_CANCELED";
    ExternalStatusEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    return ExternalStatusEnum;
  }({});
  _BackendEnums.ExternalStatusEnum = ExternalStatusEnum;
  let HistoryItemTypeEnum = /*#__PURE__*/function (HistoryItemTypeEnum) {
    HistoryItemTypeEnum["ACTIVITY"] = "ACTIVITY";
    HistoryItemTypeEnum["CREDIT_NOTE"] = "CREDIT_NOTE";
    HistoryItemTypeEnum["DOCUMENT"] = "DOCUMENT";
    HistoryItemTypeEnum["INTERNAL_NOTE"] = "INTERNAL_NOTE";
    HistoryItemTypeEnum["MESSAGE"] = "MESSAGE";
    HistoryItemTypeEnum["RATING_COMMENT"] = "RATING_COMMENT";
    HistoryItemTypeEnum["REFUND_OPTION"] = "REFUND_OPTION";
    HistoryItemTypeEnum["REFUND_REQUEST"] = "REFUND_REQUEST";
    HistoryItemTypeEnum["RETINO_SHIPPING"] = "RETINO_SHIPPING";
    HistoryItemTypeEnum["SHIPPING_REQUEST"] = "SHIPPING_REQUEST";
    HistoryItemTypeEnum["SMS_MESSAGE"] = "SMS_MESSAGE";
    HistoryItemTypeEnum["SYSTEM"] = "SYSTEM";
    HistoryItemTypeEnum["TRANSPORT"] = "TRANSPORT";
    HistoryItemTypeEnum["VOUCHER"] = "VOUCHER";
    return HistoryItemTypeEnum;
  }({});
  _BackendEnums.HistoryItemTypeEnum = HistoryItemTypeEnum;
  let InputRadiusEnum = /*#__PURE__*/function (InputRadiusEnum) {
    InputRadiusEnum["NONE"] = "none";
    InputRadiusEnum["SM"] = "sm";
    InputRadiusEnum["MD"] = "md";
    InputRadiusEnum["LG"] = "lg";
    InputRadiusEnum["FULL"] = "full";
    return InputRadiusEnum;
  }({});
  _BackendEnums.InputRadiusEnum = InputRadiusEnum;
  let InstalledPluginStatusEnum = /*#__PURE__*/function (InstalledPluginStatusEnum) {
    InstalledPluginStatusEnum["NEW"] = "NEW";
    InstalledPluginStatusEnum["SETUP_PROVIDER"] = "SETUP_PROVIDER";
    InstalledPluginStatusEnum["SETUP_CLIENT"] = "SETUP_CLIENT";
    InstalledPluginStatusEnum["ACTIVE"] = "ACTIVE";
    InstalledPluginStatusEnum["DISABLED"] = "DISABLED";
    return InstalledPluginStatusEnum;
  }({});
  _BackendEnums.InstalledPluginStatusEnum = InstalledPluginStatusEnum;
  let InternalSlugEnum = /*#__PURE__*/function (InternalSlugEnum) {
    InternalSlugEnum["TYPE_RETURN"] = "TYPE_RETURN";
    InternalSlugEnum["TYPE_WARRANTY_CLAIM"] = "TYPE_WARRANTY_CLAIM";
    InternalSlugEnum["TYPE_SUPPLIER_COMPLAINT"] = "TYPE_SUPPLIER_COMPLAINT";
    return InternalSlugEnum;
  }({});
  _BackendEnums.InternalSlugEnum = InternalSlugEnum;
  let InvoiceTypeEnum = /*#__PURE__*/function (InvoiceTypeEnum) {
    InvoiceTypeEnum["PROFORMA_INVOICE"] = "PROFORMA_INVOICE";
    InvoiceTypeEnum["ISSUED_INVOICE"] = "ISSUED_INVOICE";
    InvoiceTypeEnum["ISSUED_CREDIT_NOTICE"] = "ISSUED_CREDIT_NOTICE";
    return InvoiceTypeEnum;
  }({});
  _BackendEnums.InvoiceTypeEnum = InvoiceTypeEnum;
  let IssueTypeEnum = /*#__PURE__*/function (IssueTypeEnum) {
    IssueTypeEnum["NOT_PICKED_UP"] = "NOT_PICKED_UP";
    IssueTypeEnum["DRIVER_NOT_ASSIGNED"] = "DRIVER_NOT_ASSIGNED";
    IssueTypeEnum["IDLE_PACKAGE"] = "IDLE_PACKAGE";
    IssueTypeEnum["PICKUP_DATE_CHANGED"] = "PICKUP_DATE_CHANGED";
    return IssueTypeEnum;
  }({});
  _BackendEnums.IssueTypeEnum = IssueTypeEnum;
  let ItemTypeEnum = /*#__PURE__*/function (ItemTypeEnum) {
    ItemTypeEnum[ItemTypeEnum["VALUE_1"] = 1] = "VALUE_1";
    ItemTypeEnum[ItemTypeEnum["VALUE_2"] = 2] = "VALUE_2";
    ItemTypeEnum[ItemTypeEnum["VALUE_3"] = 3] = "VALUE_3";
    ItemTypeEnum[ItemTypeEnum["VALUE_4"] = 4] = "VALUE_4";
    ItemTypeEnum[ItemTypeEnum["VALUE_5"] = 5] = "VALUE_5";
    ItemTypeEnum[ItemTypeEnum["VALUE_6"] = 6] = "VALUE_6";
    return ItemTypeEnum;
  }({});
  _BackendEnums.ItemTypeEnum = ItemTypeEnum;
  let LabelTypeEnum = /*#__PURE__*/function (LabelTypeEnum) {
    LabelTypeEnum["PRINT_LABEL"] = "PRINT_LABEL";
    LabelTypeEnum["QR_CODE"] = "QR_CODE";
    return LabelTypeEnum;
  }({});
  _BackendEnums.LabelTypeEnum = LabelTypeEnum;
  let LanguageEnum = /*#__PURE__*/function (LanguageEnum) {
    LanguageEnum["EN"] = "en";
    LanguageEnum["DE"] = "de";
    LanguageEnum["DE-AT"] = "de-at";
    LanguageEnum["DE-CH"] = "de-ch";
    LanguageEnum["CS"] = "cs";
    LanguageEnum["SK"] = "sk";
    LanguageEnum["PL"] = "pl";
    LanguageEnum["HU"] = "hu";
    LanguageEnum["RO"] = "ro";
    LanguageEnum["ES"] = "es";
    LanguageEnum["IT"] = "it";
    LanguageEnum["IT-CH"] = "it-ch";
    LanguageEnum["FR"] = "fr";
    LanguageEnum["FR-CH"] = "fr-ch";
    LanguageEnum["FR-BE"] = "fr-be";
    LanguageEnum["HR"] = "hr";
    LanguageEnum["BG"] = "bg";
    LanguageEnum["SL"] = "sl";
    LanguageEnum["EL"] = "el";
    LanguageEnum["NL"] = "nl";
    LanguageEnum["NL-BE"] = "nl-be";
    LanguageEnum["NB"] = "nb";
    LanguageEnum["LV"] = "lv";
    LanguageEnum["LT"] = "lt";
    LanguageEnum["ET"] = "et";
    LanguageEnum["DA"] = "da";
    LanguageEnum["SV"] = "sv";
    LanguageEnum["FI"] = "fi";
    LanguageEnum["PT"] = "pt";
    LanguageEnum["UK"] = "uk";
    return LanguageEnum;
  }({});
  _BackendEnums.LanguageEnum = LanguageEnum;
  let MessageListTypeEnum = /*#__PURE__*/function (MessageListTypeEnum) {
    MessageListTypeEnum["AGENT_MESSAGE"] = "AGENT_MESSAGE";
    MessageListTypeEnum["CUSTOMER_MESSAGE"] = "CUSTOMER_MESSAGE";
    MessageListTypeEnum["OTHERS_MESSAGE"] = "OTHERS_MESSAGE";
    MessageListTypeEnum["EMAIL"] = "EMAIL";
    MessageListTypeEnum["SMS"] = "SMS";
    return MessageListTypeEnum;
  }({});
  _BackendEnums.MessageListTypeEnum = MessageListTypeEnum;
  let ModeEnum = /*#__PURE__*/function (ModeEnum) {
    ModeEnum["AUTOMATIC"] = "AUTOMATIC";
    ModeEnum["SUBSCRIPTIONS"] = "SUBSCRIPTIONS";
    return ModeEnum;
  }({});
  _BackendEnums.ModeEnum = ModeEnum;
  let NotificationTypeEnum = /*#__PURE__*/function (NotificationTypeEnum) {
    NotificationTypeEnum["TICKET_MESSAGE_ADDED_BY_CUSTOMER"] = "TICKET_MESSAGE_ADDED_BY_CUSTOMER";
    NotificationTypeEnum["TICKET_MESSAGE_UNDELIVERED"] = "TICKET_MESSAGE_UNDELIVERED";
    NotificationTypeEnum["TICKET_CREATED_BY_CUSTOMER"] = "TICKET_CREATED_BY_CUSTOMER";
    NotificationTypeEnum["TICKET_UPCOMING_DATE"] = "TICKET_UPCOMING_DATE";
    NotificationTypeEnum["TICKET_ASSIGNED"] = "TICKET_ASSIGNED";
    NotificationTypeEnum["TICKET_RATED"] = "TICKET_RATED";
    NotificationTypeEnum["ACTIVITY_DEADLINE_EXPIRES"] = "ACTIVITY_DEADLINE_EXPIRES";
    NotificationTypeEnum["ACTIVITY_CREATED"] = "ACTIVITY_CREATED";
    return NotificationTypeEnum;
  }({});
  _BackendEnums.NotificationTypeEnum = NotificationTypeEnum;
  let OpenAIChatCompletionResponseStatusEnum = /*#__PURE__*/function (OpenAIChatCompletionResponseStatusEnum) {
    OpenAIChatCompletionResponseStatusEnum["SUCCESS"] = "success";
    OpenAIChatCompletionResponseStatusEnum["ERROR"] = "error";
    return OpenAIChatCompletionResponseStatusEnum;
  }({});
  _BackendEnums.OpenAIChatCompletionResponseStatusEnum = OpenAIChatCompletionResponseStatusEnum;
  let PaymentMethodEnum = /*#__PURE__*/function (PaymentMethodEnum) {
    PaymentMethodEnum["TRANSFER"] = "TRANSFER";
    PaymentMethodEnum["CARD"] = "CARD";
    return PaymentMethodEnum;
  }({});
  _BackendEnums.PaymentMethodEnum = PaymentMethodEnum;
  let PaymentStateEnum = /*#__PURE__*/function (PaymentStateEnum) {
    PaymentStateEnum["NEW"] = "new";
    PaymentStateEnum["UNPAID"] = "unpaid";
    PaymentStateEnum["CONCLUDED"] = "concluded";
    PaymentStateEnum["PAID"] = "paid";
    PaymentStateEnum["CANCELED"] = "canceled";
    PaymentStateEnum["REFUND"] = "refund";
    return PaymentStateEnum;
  }({});
  _BackendEnums.PaymentStateEnum = PaymentStateEnum;
  let PhonePrefixEnum = /*#__PURE__*/function (PhonePrefixEnum) {
    PhonePrefixEnum["+420"] = "+420";
    PhonePrefixEnum["+421"] = "+421";
    return PhonePrefixEnum;
  }({});
  _BackendEnums.PhonePrefixEnum = PhonePrefixEnum;
  let PlatformEnum = /*#__PURE__*/function (PlatformEnum) {
    PlatformEnum["SHOPTET"] = "SHOPTET";
    PlatformEnum["UPGATES"] = "UPGATES";
    PlatformEnum["SHOPIFY"] = "SHOPIFY";
    PlatformEnum["PRESTASHOP"] = "PRESTASHOP";
    PlatformEnum["NETDIRECT"] = "NETDIRECT";
    PlatformEnum["WOOCOMMERCE"] = "WOOCOMMERCE";
    PlatformEnum["MAGENTO_2"] = "MAGENTO_2";
    PlatformEnum["SHOPSYS"] = "SHOPSYS";
    PlatformEnum["SIMPLIA"] = "SIMPLIA";
    PlatformEnum["SHOPRENTER"] = "SHOPRENTER";
    PlatformEnum["BYZNYSWEB"] = "BYZNYSWEB";
    PlatformEnum["CUSTOM"] = "CUSTOM";
    PlatformEnum["MULTIPLATFORM"] = "MULTIPLATFORM";
    return PlatformEnum;
  }({});
  _BackendEnums.PlatformEnum = PlatformEnum;
  let ProductCustomFieldTypeEnum = /*#__PURE__*/function (ProductCustomFieldTypeEnum) {
    ProductCustomFieldTypeEnum["CHAR"] = "CHAR";
    ProductCustomFieldTypeEnum["MULTILINE"] = "MULTILINE";
    ProductCustomFieldTypeEnum["DATE"] = "DATE";
    ProductCustomFieldTypeEnum["SELECT"] = "SELECT";
    ProductCustomFieldTypeEnum["FILE"] = "FILE";
    ProductCustomFieldTypeEnum["LINK"] = "LINK";
    return ProductCustomFieldTypeEnum;
  }({});
  _BackendEnums.ProductCustomFieldTypeEnum = ProductCustomFieldTypeEnum;
  let ProductFieldEnum = /*#__PURE__*/function (ProductFieldEnum) {
    ProductFieldEnum["MANUFACTURER"] = "manufacturer";
    ProductFieldEnum["CATEGORY"] = "category";
    ProductFieldEnum["VARIANT"] = "variant";
    ProductFieldEnum["PRODUCT_ID"] = "product_id";
    ProductFieldEnum["EAN"] = "ean";
    ProductFieldEnum["SERIAL"] = "serial";
    return ProductFieldEnum;
  }({});
  _BackendEnums.ProductFieldEnum = ProductFieldEnum;
  let QrCodeRefundVariableSymbolSourceEnum = /*#__PURE__*/function (QrCodeRefundVariableSymbolSourceEnum) {
    QrCodeRefundVariableSymbolSourceEnum["TICKET_CODE"] = "TICKET_CODE";
    QrCodeRefundVariableSymbolSourceEnum["ORDER_CODE"] = "ORDER_CODE";
    QrCodeRefundVariableSymbolSourceEnum["CREDIT_NOTE_VARIABLE_SYMBOL"] = "CREDIT_NOTE_VARIABLE_SYMBOL";
    return QrCodeRefundVariableSymbolSourceEnum;
  }({});
  _BackendEnums.QrCodeRefundVariableSymbolSourceEnum = QrCodeRefundVariableSymbolSourceEnum;
  let RefundAccountCurrencyEnum = /*#__PURE__*/function (RefundAccountCurrencyEnum) {
    RefundAccountCurrencyEnum["CZK"] = "CZK";
    RefundAccountCurrencyEnum["EUR"] = "EUR";
    RefundAccountCurrencyEnum["HUF"] = "HUF";
    RefundAccountCurrencyEnum["USD"] = "USD";
    RefundAccountCurrencyEnum["GBP"] = "GBP";
    RefundAccountCurrencyEnum["CHF"] = "CHF";
    RefundAccountCurrencyEnum["JPY"] = "JPY";
    RefundAccountCurrencyEnum["CAD"] = "CAD";
    RefundAccountCurrencyEnum["AUD"] = "AUD";
    RefundAccountCurrencyEnum["PLN"] = "PLN";
    RefundAccountCurrencyEnum["NOK"] = "NOK";
    RefundAccountCurrencyEnum["SEK"] = "SEK";
    return RefundAccountCurrencyEnum;
  }({});
  _BackendEnums.RefundAccountCurrencyEnum = RefundAccountCurrencyEnum;
  let RefundBatchStatusEnum = /*#__PURE__*/function (RefundBatchStatusEnum) {
    RefundBatchStatusEnum["UNPROCESSED"] = "unprocessed";
    RefundBatchStatusEnum["PROCESSED"] = "processed";
    RefundBatchStatusEnum["FAILED"] = "failed";
    RefundBatchStatusEnum["RETRYING"] = "retrying";
    return RefundBatchStatusEnum;
  }({});
  _BackendEnums.RefundBatchStatusEnum = RefundBatchStatusEnum;
  let RefundClientTypeEnum = /*#__PURE__*/function (RefundClientTypeEnum) {
    RefundClientTypeEnum["ABO"] = "ABO";
    RefundClientTypeEnum["FIO_ABO"] = "FIO_ABO";
    RefundClientTypeEnum["FIO_PAIN"] = "FIO_PAIN";
    RefundClientTypeEnum["FIO_FOREIGN"] = "FIO_FOREIGN";
    RefundClientTypeEnum["PAIN"] = "PAIN";
    RefundClientTypeEnum["CUSTOM"] = "CUSTOM";
    RefundClientTypeEnum["WEBHOOK"] = "WEBHOOK";
    return RefundClientTypeEnum;
  }({});
  _BackendEnums.RefundClientTypeEnum = RefundClientTypeEnum;
  let RefundOptionTypeEnum = /*#__PURE__*/function (RefundOptionTypeEnum) {
    RefundOptionTypeEnum["TO_BANK_ACCOUNT"] = "TO_BANK_ACCOUNT";
    RefundOptionTypeEnum["VOUCHER"] = "VOUCHER";
    RefundOptionTypeEnum["CUSTOM"] = "CUSTOM";
    RefundOptionTypeEnum["WEBHOOK"] = "WEBHOOK";
    return RefundOptionTypeEnum;
  }({});
  _BackendEnums.RefundOptionTypeEnum = RefundOptionTypeEnum;
  let ResultTypeEnum = /*#__PURE__*/function (ResultTypeEnum) {
    ResultTypeEnum["TICKETS"] = "TICKETS";
    ResultTypeEnum["ACTIVITIES"] = "ACTIVITIES";
    ResultTypeEnum["RETINO_SHIPPING"] = "RETINO_SHIPPING";
    ResultTypeEnum["TICKET_PRODUCTS"] = "TICKET_PRODUCTS";
    ResultTypeEnum["CUSTOMERS"] = "CUSTOMERS";
    ResultTypeEnum["TRACKED_SHIPPING"] = "TRACKED_SHIPPING";
    return ResultTypeEnum;
  }({});
  _BackendEnums.ResultTypeEnum = ResultTypeEnum;
  let RoleEnum = /*#__PURE__*/function (RoleEnum) {
    RoleEnum["AGENT"] = "agent";
    RoleEnum["MANAGER"] = "manager";
    return RoleEnum;
  }({});
  _BackendEnums.RoleEnum = RoleEnum;
  let SectionNameEnum = /*#__PURE__*/function (SectionNameEnum) {
    SectionNameEnum["PRODUCTS"] = "PRODUCTS";
    SectionNameEnum["INFO"] = "INFO";
    SectionNameEnum["HISTORY"] = "HISTORY";
    SectionNameEnum["CUSTOMER"] = "CUSTOMER";
    SectionNameEnum["ORDER_ITEMS"] = "ORDER_ITEMS";
    return SectionNameEnum;
  }({});
  _BackendEnums.SectionNameEnum = SectionNameEnum;
  let SelectedRefundOptionStatusEnum = /*#__PURE__*/function (SelectedRefundOptionStatusEnum) {
    SelectedRefundOptionStatusEnum["WAITING"] = "WAITING";
    SelectedRefundOptionStatusEnum["ACCEPTED"] = "ACCEPTED";
    SelectedRefundOptionStatusEnum["DENIED"] = "DENIED";
    return SelectedRefundOptionStatusEnum;
  }({});
  _BackendEnums.SelectedRefundOptionStatusEnum = SelectedRefundOptionStatusEnum;
  let SettingDealQualificationTicketCountEstimateEnum = /*#__PURE__*/function (SettingDealQualificationTicketCountEstimateEnum) {
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_21"] = 21] = "VALUE_21";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_22"] = 22] = "VALUE_22";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_23"] = 23] = "VALUE_23";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_24"] = 24] = "VALUE_24";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_25"] = 25] = "VALUE_25";
    return SettingDealQualificationTicketCountEstimateEnum;
  }({});
  _BackendEnums.SettingDealQualificationTicketCountEstimateEnum = SettingDealQualificationTicketCountEstimateEnum;
  let ShippingListBulkActionActionEnum = /*#__PURE__*/function (ShippingListBulkActionActionEnum) {
    ShippingListBulkActionActionEnum["CONFIRM"] = "confirm";
    ShippingListBulkActionActionEnum["DECLINE"] = "decline";
    return ShippingListBulkActionActionEnum;
  }({});
  _BackendEnums.ShippingListBulkActionActionEnum = ShippingListBulkActionActionEnum;
  let ShippingPriceEnum = /*#__PURE__*/function (ShippingPriceEnum) {
    ShippingPriceEnum["BEFOREDISCOUNT"] = "beforeDiscount";
    ShippingPriceEnum["CART"] = "cart";
    ShippingPriceEnum["FREE"] = "free";
    return ShippingPriceEnum;
  }({});
  _BackendEnums.ShippingPriceEnum = ShippingPriceEnum;
  let ShippingProviderConfigSubmitTypeEnum = /*#__PURE__*/function (ShippingProviderConfigSubmitTypeEnum) {
    ShippingProviderConfigSubmitTypeEnum["DROP_OFF"] = "DROP_OFF";
    ShippingProviderConfigSubmitTypeEnum["PICKUP"] = "PICKUP";
    ShippingProviderConfigSubmitTypeEnum["FREIGHT"] = "FREIGHT";
    ShippingProviderConfigSubmitTypeEnum["CUSTOM"] = "CUSTOM";
    return ShippingProviderConfigSubmitTypeEnum;
  }({});
  _BackendEnums.ShippingProviderConfigSubmitTypeEnum = ShippingProviderConfigSubmitTypeEnum;
  let ShippingProvidersEnum = /*#__PURE__*/function (ShippingProvidersEnum) {
    ShippingProvidersEnum["CUSTOM"] = "CUSTOM";
    ShippingProvidersEnum["DHL24_PICKUP"] = "DHL24_PICKUP";
    ShippingProvidersEnum["DHL24_DROP_OFF"] = "DHL24_DROP_OFF";
    ShippingProvidersEnum["DHL_FREIGHT_PICKUP"] = "DHL_FREIGHT_PICKUP";
    ShippingProvidersEnum["DHL_INTERNATIONAL_DROPOFF"] = "DHL_INTERNATIONAL_DROPOFF";
    ShippingProvidersEnum["DPD_BELGIUM_DROPOFF"] = "DPD_BELGIUM_DROPOFF";
    ShippingProvidersEnum["DPD_GEO_API_DROPOFF"] = "DPD_GEO_API_DROPOFF";
    ShippingProvidersEnum["DPD_GEO_API_PICKUP"] = "DPD_GEO_API_PICKUP";
    ShippingProvidersEnum["DPD_REG_PRIJEMCE_PICKUP"] = "DPD_REG_PRIJEMCE_PICKUP";
    ShippingProvidersEnum["DPD_REG_PRIJEMCE_DROPOFF"] = "DPD_REG_PRIJEMCE_DROPOFF";
    ShippingProvidersEnum["DPD_SK_PICKUP"] = "DPD_SK_PICKUP";
    ShippingProvidersEnum["DPD_SK_DROPOFF"] = "DPD_SK_DROPOFF";
    ShippingProvidersEnum["GEIS_PICKUP"] = "GEIS_PICKUP";
    ShippingProvidersEnum["GLS_PICKUP"] = "GLS_PICKUP";
    ShippingProvidersEnum["GLS_ISRS"] = "GLS_ISRS";
    ShippingProvidersEnum["GLS_POLAND_API_DROPOFF"] = "GLS_POLAND_API_DROPOFF";
    ShippingProvidersEnum["INPOST_DROP_OFF"] = "INPOST_DROP_OFF";
    ShippingProvidersEnum["INPOST_PICKUP"] = "INPOST_PICKUP";
    ShippingProvidersEnum["LIFTAGO"] = "LIFTAGO";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_CZ"] = "MY_GLS_DROP_OFF_CZ";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_SK"] = "MY_GLS_DROP_OFF_SK";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_HU"] = "MY_GLS_DROP_OFF_HU";
    ShippingProvidersEnum["MY_GLS_PICKUP_CZ"] = "MY_GLS_PICKUP_CZ";
    ShippingProvidersEnum["MY_GLS_PICKUP_SK"] = "MY_GLS_PICKUP_SK";
    ShippingProvidersEnum["MY_GLS_PICKUP_HU"] = "MY_GLS_PICKUP_HU";
    ShippingProvidersEnum["MY_GLS_PICKUP_SI"] = "MY_GLS_PICKUP_SI";
    ShippingProvidersEnum["MY_GLS_PICKUP_HR"] = "MY_GLS_PICKUP_HR";
    ShippingProvidersEnum["MY_PPL_PICKUP"] = "MY_PPL_PICKUP";
    ShippingProvidersEnum["PACKETA_CLAIM_ASSISTANT"] = "PACKETA_CLAIM_ASSISTANT";
    ShippingProvidersEnum["MY_PPL_CPL_DROPOFF"] = "MY_PPL_CPL_DROPOFF";
    ShippingProvidersEnum["MY_PPL_CPL_PICKUP"] = "MY_PPL_CPL_PICKUP";
    ShippingProvidersEnum["PPL_RETURN_CONNECT_DROPOFF"] = "PPL_RETURN_CONNECT_DROPOFF";
    ShippingProvidersEnum["PPL_RETURN_CONNECT_PICKUP"] = "PPL_RETURN_CONNECT_PICKUP";
    ShippingProvidersEnum["UPS_PICKUP"] = "UPS_PICKUP";
    return ShippingProvidersEnum;
  }({});
  _BackendEnums.ShippingProvidersEnum = ShippingProvidersEnum;
  let ShippingProvidersListResponseSubmitTypeEnum = /*#__PURE__*/function (ShippingProvidersListResponseSubmitTypeEnum) {
    ShippingProvidersListResponseSubmitTypeEnum["PICKUP"] = "PICKUP";
    ShippingProvidersListResponseSubmitTypeEnum["DROP_OFF"] = "DROP_OFF";
    ShippingProvidersListResponseSubmitTypeEnum["OTHER"] = "OTHER";
    return ShippingProvidersListResponseSubmitTypeEnum;
  }({});
  _BackendEnums.ShippingProvidersListResponseSubmitTypeEnum = ShippingProvidersListResponseSubmitTypeEnum;
  let ShippingStatusEnum = /*#__PURE__*/function (ShippingStatusEnum) {
    ShippingStatusEnum["CONFIRMATION_REQUIRED"] = "CONFIRMATION_REQUIRED";
    ShippingStatusEnum["WAITING"] = "WAITING";
    ShippingStatusEnum["SYNCING"] = "SYNCING";
    ShippingStatusEnum["FINISHED"] = "FINISHED";
    ShippingStatusEnum["REFUNDED"] = "REFUNDED";
    ShippingStatusEnum["CANCELED"] = "CANCELED";
    ShippingStatusEnum["DECLINED"] = "DECLINED";
    ShippingStatusEnum["FAILURE"] = "FAILURE";
    ShippingStatusEnum["VOIDED"] = "VOIDED";
    return ShippingStatusEnum;
  }({});
  _BackendEnums.ShippingStatusEnum = ShippingStatusEnum;
  let ShoptetVoucherDiscountTypeEnum = /*#__PURE__*/function (ShoptetVoucherDiscountTypeEnum) {
    ShoptetVoucherDiscountTypeEnum["FIXED"] = "fixed";
    ShoptetVoucherDiscountTypeEnum["PERCENTUAL"] = "percentual";
    return ShoptetVoucherDiscountTypeEnum;
  }({});
  _BackendEnums.ShoptetVoucherDiscountTypeEnum = ShoptetVoucherDiscountTypeEnum;
  let TicketFieldEnum = /*#__PURE__*/function (TicketFieldEnum) {
    TicketFieldEnum["ORDER_ID"] = "order_id";
    TicketFieldEnum["CUSTOMER_EMAIL"] = "customer_email";
    TicketFieldEnum["CUSTOMER_NAME"] = "customer_name";
    TicketFieldEnum["CUSTOMER_PHONE"] = "customer_phone";
    return TicketFieldEnum;
  }({});
  _BackendEnums.TicketFieldEnum = TicketFieldEnum;
  let TicketTypeInternalSlugEnum = /*#__PURE__*/function (TicketTypeInternalSlugEnum) {
    TicketTypeInternalSlugEnum["TYPE_RETURN"] = "TYPE_RETURN";
    TicketTypeInternalSlugEnum["TYPE_WARRANTY_CLAIM"] = "TYPE_WARRANTY_CLAIM";
    TicketTypeInternalSlugEnum["TYPE_SUPPLIER_COMPLAINT"] = "TYPE_SUPPLIER_COMPLAINT";
    return TicketTypeInternalSlugEnum;
  }({});
  _BackendEnums.TicketTypeInternalSlugEnum = TicketTypeInternalSlugEnum;
  let TransportProviderEnum = /*#__PURE__*/function (TransportProviderEnum) {
    TransportProviderEnum["ZASILKOVNA"] = "ZASILKOVNA";
    TransportProviderEnum["GLS"] = "GLS";
    TransportProviderEnum["MY_GLS"] = "MY_GLS";
    TransportProviderEnum["MY_GLS_DROPOFF"] = "MY_GLS_DROPOFF";
    TransportProviderEnum["PPL"] = "PPL";
    TransportProviderEnum["DPD_PICKUP"] = "DPD_PICKUP";
    TransportProviderEnum["DPD_DROPOFF"] = "DPD_DROPOFF";
    TransportProviderEnum["RETINO_PPL"] = "RETINO_PPL";
    TransportProviderEnum["CUSTOMER_RETINO_PPL"] = "CUSTOMER_RETINO_PPL";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_PICKUP"] = "CUSTOMER_RETINO_GLS_PICKUP";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_DROPOFF"] = "CUSTOMER_RETINO_GLS_DROPOFF";
    TransportProviderEnum["LIFTAGO"] = "LIFTAGO";
    TransportProviderEnum["LIFTAGO_RETINO_PPL"] = "LIFTAGO_RETINO_PPL";
    TransportProviderEnum["GEIS"] = "GEIS";
    TransportProviderEnum["GLS_DROPOFF_PL"] = "GLS_DROPOFF_PL";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_PICKUP_SK"] = "CUSTOMER_RETINO_GLS_PICKUP_SK";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_PICKUP_HU"] = "CUSTOMER_RETINO_GLS_PICKUP_HU";
    TransportProviderEnum["RETURN_CONNECT"] = "RETURN_CONNECT";
    TransportProviderEnum["DHL_FREIGHT"] = "DHL_FREIGHT";
    TransportProviderEnum["DHL_DROPOFF"] = "DHL_DROPOFF";
    TransportProviderEnum["CUSTOM_OTHER_PROVIDER"] = "CUSTOM_OTHER_PROVIDER";
    return TransportProviderEnum;
  }({});
  _BackendEnums.TransportProviderEnum = TransportProviderEnum;
  let TransportStatusEnum = /*#__PURE__*/function (TransportStatusEnum) {
    TransportStatusEnum["STATUS_PENDING_CONFIRMATION"] = "STATUS_PENDING_CONFIRMATION";
    TransportStatusEnum["STATUS_INIT"] = "STATUS_INIT";
    TransportStatusEnum["STATUS_ACCEPTED"] = "STATUS_ACCEPTED";
    TransportStatusEnum["STATUS_SUBMITTED"] = "STATUS_SUBMITTED";
    TransportStatusEnum["STATUS_TRANSPORT"] = "STATUS_TRANSPORT";
    TransportStatusEnum["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    TransportStatusEnum["STATUS_UNDELIVERED"] = "STATUS_UNDELIVERED";
    TransportStatusEnum["STATUS_CANCELED"] = "STATUS_CANCELED";
    TransportStatusEnum["STATUS_WAITING_FOR_ORDERING"] = "STATUS_WAITING_FOR_ORDERING";
    TransportStatusEnum["STATUS_REFUNDED"] = "STATUS_REFUNDED";
    TransportStatusEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    return TransportStatusEnum;
  }({});
  _BackendEnums.TransportStatusEnum = TransportStatusEnum;
  let TriggerConditionTypeEnum = /*#__PURE__*/function (TriggerConditionTypeEnum) {
    TriggerConditionTypeEnum["STATE"] = "STATE";
    TriggerConditionTypeEnum["TYPE"] = "TYPE";
    TriggerConditionTypeEnum["TAG"] = "TAG";
    TriggerConditionTypeEnum["TICKET_LANGUAGE"] = "TICKET_LANGUAGE";
    TriggerConditionTypeEnum["TICKET_COUNTRY"] = "TICKET_COUNTRY";
    TriggerConditionTypeEnum["TICKET_OWNER"] = "TICKET_OWNER";
    TriggerConditionTypeEnum["TICKET_BOUND_ORDER"] = "TICKET_BOUND_ORDER";
    TriggerConditionTypeEnum["TICKET_VERIFICATION_STATE"] = "TICKET_VERIFICATION_STATE";
    TriggerConditionTypeEnum["TICKET_CURRENCY"] = "TICKET_CURRENCY";
    TriggerConditionTypeEnum["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    TriggerConditionTypeEnum["PREFERRED_SHIPPING"] = "PREFERRED_SHIPPING";
    TriggerConditionTypeEnum["NUMBER_OF_PRODUCTS"] = "NUMBER_OF_PRODUCTS";
    TriggerConditionTypeEnum["SHIPPING_EXTERNAL_STATUS"] = "SHIPPING_EXTERNAL_STATUS";
    TriggerConditionTypeEnum["ORDER_DATE"] = "ORDER_DATE";
    TriggerConditionTypeEnum["TICKET_VALUE"] = "TICKET_VALUE";
    TriggerConditionTypeEnum["ORDER_VALUE"] = "ORDER_VALUE";
    return TriggerConditionTypeEnum;
  }({});
  _BackendEnums.TriggerConditionTypeEnum = TriggerConditionTypeEnum;
  let TriggerLogStateEnum = /*#__PURE__*/function (TriggerLogStateEnum) {
    TriggerLogStateEnum["SUCCESS"] = "SUCCESS";
    TriggerLogStateEnum["FAILED"] = "FAILED";
    TriggerLogStateEnum["CAN_RETRY"] = "CAN_RETRY";
    return TriggerLogStateEnum;
  }({});
  _BackendEnums.TriggerLogStateEnum = TriggerLogStateEnum;
  let TriggerTypeEnum = /*#__PURE__*/function (TriggerTypeEnum) {
    TriggerTypeEnum["TICKET_CREATED_BY_CUSTOMER"] = "TICKET_CREATED_BY_CUSTOMER";
    TriggerTypeEnum["TICKET_CREATED_BY_AGENT"] = "TICKET_CREATED_BY_AGENT";
    TriggerTypeEnum["TICKET_STATE_CHANGED"] = "TICKET_STATE_CHANGED";
    TriggerTypeEnum["TICKET_TAG_ADDED"] = "TICKET_TAG_ADDED";
    TriggerTypeEnum["TICKET_CLOSED"] = "TICKET_CLOSED";
    TriggerTypeEnum["TICKET_OWNER_CHANGED"] = "TICKET_OWNER_CHANGED";
    TriggerTypeEnum["CUSTOMER_SENT_MESSAGE"] = "CUSTOMER_SENT_MESSAGE";
    TriggerTypeEnum["REFUND_REQUEST_CREATED"] = "REFUND_REQUEST_CREATED";
    TriggerTypeEnum["ACTIVITY_CREATED"] = "ACTIVITY_CREATED";
    TriggerTypeEnum["ACTIVITY_DEADLINE_EXPIRED"] = "ACTIVITY_DEADLINE_EXPIRED";
    TriggerTypeEnum["SHIPPING_STATUS_CHANGED"] = "SHIPPING_STATUS_CHANGED";
    return TriggerTypeEnum;
  }({});
  _BackendEnums.TriggerTypeEnum = TriggerTypeEnum;
  let UsageTypeEnum = /*#__PURE__*/function (UsageTypeEnum) {
    UsageTypeEnum["LICENSED"] = "LICENSED";
    UsageTypeEnum["METERED"] = "METERED";
    return UsageTypeEnum;
  }({});
  _BackendEnums.UsageTypeEnum = UsageTypeEnum;
  let UserLanguageEnum = /*#__PURE__*/function (UserLanguageEnum) {
    UserLanguageEnum["EN"] = "en";
    UserLanguageEnum["DE"] = "de";
    UserLanguageEnum["CS"] = "cs";
    UserLanguageEnum["SK"] = "sk";
    UserLanguageEnum["PL"] = "pl";
    UserLanguageEnum["HU"] = "hu";
    UserLanguageEnum["RO"] = "ro";
    UserLanguageEnum["ES"] = "es";
    UserLanguageEnum["IT"] = "it";
    UserLanguageEnum["FR"] = "fr";
    UserLanguageEnum["HR"] = "hr";
    UserLanguageEnum["BG"] = "bg";
    UserLanguageEnum["SL"] = "sl";
    UserLanguageEnum["EL"] = "el";
    UserLanguageEnum["NL"] = "nl";
    UserLanguageEnum["NB"] = "nb";
    UserLanguageEnum["LV"] = "lv";
    UserLanguageEnum["LT"] = "lt";
    UserLanguageEnum["ET"] = "et";
    UserLanguageEnum["DA"] = "da";
    UserLanguageEnum["SV"] = "sv";
    UserLanguageEnum["FI"] = "fi";
    UserLanguageEnum["PT"] = "pt";
    UserLanguageEnum["UK"] = "uk";
    return UserLanguageEnum;
  }({});
  _BackendEnums.UserLanguageEnum = UserLanguageEnum;
  let ValueEnum = /*#__PURE__*/function (ValueEnum) {
    ValueEnum["AGENT"] = "agent";
    ValueEnum["MANAGER"] = "manager";
    return ValueEnum;
  }({});
  _BackendEnums.ValueEnum = ValueEnum;
  let VariableSymbolSourceEnum = /*#__PURE__*/function (VariableSymbolSourceEnum) {
    VariableSymbolSourceEnum["TICKET_CODE"] = "TICKET_CODE";
    VariableSymbolSourceEnum["ORDER_CODE"] = "ORDER_CODE";
    VariableSymbolSourceEnum["CREDIT_NOTE_VARIABLE_SYMBOL"] = "CREDIT_NOTE_VARIABLE_SYMBOL";
    return VariableSymbolSourceEnum;
  }({});
  _BackendEnums.VariableSymbolSourceEnum = VariableSymbolSourceEnum;
  let VerificationStateEnum = /*#__PURE__*/function (VerificationStateEnum) {
    VerificationStateEnum["VERIFIED_AUTOMATICALLY"] = "VERIFIED_AUTOMATICALLY";
    VerificationStateEnum["VERIFIED_MANUALLY"] = "VERIFIED_MANUALLY";
    VerificationStateEnum["UNVERIFIED"] = "UNVERIFIED";
    return VerificationStateEnum;
  }({});
  _BackendEnums.VerificationStateEnum = VerificationStateEnum;
  let WebhookEndpointStatusEnum = /*#__PURE__*/function (WebhookEndpointStatusEnum) {
    WebhookEndpointStatusEnum["ENABLED"] = "enabled";
    WebhookEndpointStatusEnum["DISABLED"] = "disabled";
    return WebhookEndpointStatusEnum;
  }({});
  _BackendEnums.WebhookEndpointStatusEnum = WebhookEndpointStatusEnum;
  let WebhookStatusEnum = /*#__PURE__*/function (WebhookStatusEnum) {
    WebhookStatusEnum["PENDING"] = "pending";
    WebhookStatusEnum["SUCCESS"] = "success";
    WebhookStatusEnum["RETRYING"] = "retrying";
    WebhookStatusEnum["FAILURE"] = "failure";
    return WebhookStatusEnum;
  }({});
  _BackendEnums.WebhookStatusEnum = WebhookStatusEnum;
  let WooCommerceVoucherDiscountTypeEnum = /*#__PURE__*/function (WooCommerceVoucherDiscountTypeEnum) {
    WooCommerceVoucherDiscountTypeEnum["FIXED_CART"] = "fixed_cart";
    WooCommerceVoucherDiscountTypeEnum["PERCENT"] = "percent";
    WooCommerceVoucherDiscountTypeEnum["FIXED_PRODUCT"] = "fixed_product";
    WooCommerceVoucherDiscountTypeEnum["PERCENT_PRODUCT"] = "percent_product";
    return WooCommerceVoucherDiscountTypeEnum;
  }({});
  _BackendEnums.WooCommerceVoucherDiscountTypeEnum = WooCommerceVoucherDiscountTypeEnum;
  let ActivitiesListStatusEnum = /*#__PURE__*/function (ActivitiesListStatusEnum) {
    ActivitiesListStatusEnum["STATUS_CLOSED"] = "STATUS_CLOSED";
    ActivitiesListStatusEnum["STATUS_OPEN"] = "STATUS_OPEN";
    return ActivitiesListStatusEnum;
  }({});
  _BackendEnums.ActivitiesListStatusEnum = ActivitiesListStatusEnum;
  let BillingTransactionsListPaymentStateEnum = /*#__PURE__*/function (BillingTransactionsListPaymentStateEnum) {
    BillingTransactionsListPaymentStateEnum["CANCELED"] = "canceled";
    BillingTransactionsListPaymentStateEnum["CONCLUDED"] = "concluded";
    BillingTransactionsListPaymentStateEnum["NEW"] = "new";
    BillingTransactionsListPaymentStateEnum["PAID"] = "paid";
    BillingTransactionsListPaymentStateEnum["REFUND"] = "refund";
    BillingTransactionsListPaymentStateEnum["UNPAID"] = "unpaid";
    return BillingTransactionsListPaymentStateEnum;
  }({});
  _BackendEnums.BillingTransactionsListPaymentStateEnum = BillingTransactionsListPaymentStateEnum;
  let CommunicationListTicketLanguageEnum = /*#__PURE__*/function (CommunicationListTicketLanguageEnum) {
    CommunicationListTicketLanguageEnum["BG"] = "bg";
    CommunicationListTicketLanguageEnum["CS"] = "cs";
    CommunicationListTicketLanguageEnum["DA"] = "da";
    CommunicationListTicketLanguageEnum["DE"] = "de";
    CommunicationListTicketLanguageEnum["DE-AT"] = "de-at";
    CommunicationListTicketLanguageEnum["DE-CH"] = "de-ch";
    CommunicationListTicketLanguageEnum["EL"] = "el";
    CommunicationListTicketLanguageEnum["EN"] = "en";
    CommunicationListTicketLanguageEnum["ES"] = "es";
    CommunicationListTicketLanguageEnum["ET"] = "et";
    CommunicationListTicketLanguageEnum["FI"] = "fi";
    CommunicationListTicketLanguageEnum["FR"] = "fr";
    CommunicationListTicketLanguageEnum["FR-BE"] = "fr-be";
    CommunicationListTicketLanguageEnum["FR-CH"] = "fr-ch";
    CommunicationListTicketLanguageEnum["HR"] = "hr";
    CommunicationListTicketLanguageEnum["HU"] = "hu";
    CommunicationListTicketLanguageEnum["IT"] = "it";
    CommunicationListTicketLanguageEnum["IT-CH"] = "it-ch";
    CommunicationListTicketLanguageEnum["LT"] = "lt";
    CommunicationListTicketLanguageEnum["LV"] = "lv";
    CommunicationListTicketLanguageEnum["NB"] = "nb";
    CommunicationListTicketLanguageEnum["NL"] = "nl";
    CommunicationListTicketLanguageEnum["NL-BE"] = "nl-be";
    CommunicationListTicketLanguageEnum["PL"] = "pl";
    CommunicationListTicketLanguageEnum["PT"] = "pt";
    CommunicationListTicketLanguageEnum["RO"] = "ro";
    CommunicationListTicketLanguageEnum["SK"] = "sk";
    CommunicationListTicketLanguageEnum["SL"] = "sl";
    CommunicationListTicketLanguageEnum["SV"] = "sv";
    CommunicationListTicketLanguageEnum["UK"] = "uk";
    return CommunicationListTicketLanguageEnum;
  }({});
  _BackendEnums.CommunicationListTicketLanguageEnum = CommunicationListTicketLanguageEnum;
  let CustomFieldsListTypeEnum = /*#__PURE__*/function (CustomFieldsListTypeEnum) {
    CustomFieldsListTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    CustomFieldsListTypeEnum["BOOL"] = "BOOL";
    CustomFieldsListTypeEnum["CHAR"] = "CHAR";
    CustomFieldsListTypeEnum["CZECH_BANK_ACCOUNT"] = "CZECH_BANK_ACCOUNT";
    CustomFieldsListTypeEnum["DATE"] = "DATE";
    CustomFieldsListTypeEnum["FILE"] = "FILE";
    CustomFieldsListTypeEnum["IBAN"] = "IBAN";
    CustomFieldsListTypeEnum["MULTILINE"] = "MULTILINE";
    CustomFieldsListTypeEnum["NUMERIC"] = "NUMERIC";
    CustomFieldsListTypeEnum["SELECT"] = "SELECT";
    CustomFieldsListTypeEnum["SELECTMULTI"] = "SELECTMULTI";
    CustomFieldsListTypeEnum["URL"] = "URL";
    return CustomFieldsListTypeEnum;
  }({});
  _BackendEnums.CustomFieldsListTypeEnum = CustomFieldsListTypeEnum;
  let RefundAccountsListCurrencyEnum = /*#__PURE__*/function (RefundAccountsListCurrencyEnum) {
    RefundAccountsListCurrencyEnum["AUD"] = "AUD";
    RefundAccountsListCurrencyEnum["CAD"] = "CAD";
    RefundAccountsListCurrencyEnum["CHF"] = "CHF";
    RefundAccountsListCurrencyEnum["CZK"] = "CZK";
    RefundAccountsListCurrencyEnum["EUR"] = "EUR";
    RefundAccountsListCurrencyEnum["GBP"] = "GBP";
    RefundAccountsListCurrencyEnum["HUF"] = "HUF";
    RefundAccountsListCurrencyEnum["JPY"] = "JPY";
    RefundAccountsListCurrencyEnum["NOK"] = "NOK";
    RefundAccountsListCurrencyEnum["PLN"] = "PLN";
    RefundAccountsListCurrencyEnum["SEK"] = "SEK";
    RefundAccountsListCurrencyEnum["USD"] = "USD";
    return RefundAccountsListCurrencyEnum;
  }({});
  _BackendEnums.RefundAccountsListCurrencyEnum = RefundAccountsListCurrencyEnum;
  let RetinoShippingShippingListListShippingProviderEnum = /*#__PURE__*/function (RetinoShippingShippingListListShippingProviderEnum) {
    RetinoShippingShippingListListShippingProviderEnum["CUSTOM"] = "CUSTOM";
    RetinoShippingShippingListListShippingProviderEnum["DHL24_DROP_OFF"] = "DHL24_DROP_OFF";
    RetinoShippingShippingListListShippingProviderEnum["DHL24_PICKUP"] = "DHL24_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DHL_FREIGHT_PICKUP"] = "DHL_FREIGHT_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DHL_INTERNATIONAL_DROPOFF"] = "DHL_INTERNATIONAL_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_BELGIUM_DROPOFF"] = "DPD_BELGIUM_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_GEO_API_DROPOFF"] = "DPD_GEO_API_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_GEO_API_PICKUP"] = "DPD_GEO_API_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_DROPOFF"] = "DPD_REG_PRIJEMCE_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_PICKUP"] = "DPD_REG_PRIJEMCE_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DPD_SK_DROPOFF"] = "DPD_SK_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_SK_PICKUP"] = "DPD_SK_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["GEIS_PICKUP"] = "GEIS_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["GLS_ISRS"] = "GLS_ISRS";
    RetinoShippingShippingListListShippingProviderEnum["GLS_PICKUP"] = "GLS_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["GLS_POLAND_API_DROPOFF"] = "GLS_POLAND_API_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["INPOST_DROP_OFF"] = "INPOST_DROP_OFF";
    RetinoShippingShippingListListShippingProviderEnum["INPOST_PICKUP"] = "INPOST_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["LIFTAGO"] = "LIFTAGO";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_CZ"] = "MY_GLS_DROP_OFF_CZ";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_HU"] = "MY_GLS_DROP_OFF_HU";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_SK"] = "MY_GLS_DROP_OFF_SK";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_CZ"] = "MY_GLS_PICKUP_CZ";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HR"] = "MY_GLS_PICKUP_HR";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HU"] = "MY_GLS_PICKUP_HU";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SI"] = "MY_GLS_PICKUP_SI";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SK"] = "MY_GLS_PICKUP_SK";
    RetinoShippingShippingListListShippingProviderEnum["MY_PPL_CPL_DROPOFF"] = "MY_PPL_CPL_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["MY_PPL_CPL_PICKUP"] = "MY_PPL_CPL_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["MY_PPL_PICKUP"] = "MY_PPL_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["PACKETA_CLAIM_ASSISTANT"] = "PACKETA_CLAIM_ASSISTANT";
    RetinoShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_DROPOFF"] = "PPL_RETURN_CONNECT_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_PICKUP"] = "PPL_RETURN_CONNECT_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["UPS_PICKUP"] = "UPS_PICKUP";
    return RetinoShippingShippingListListShippingProviderEnum;
  }({});
  _BackendEnums.RetinoShippingShippingListListShippingProviderEnum = RetinoShippingShippingListListShippingProviderEnum;
  let ShippingListStatusEnum = /*#__PURE__*/function (ShippingListStatusEnum) {
    ShippingListStatusEnum["STATUS_ACCEPTED"] = "STATUS_ACCEPTED";
    ShippingListStatusEnum["STATUS_CANCELED"] = "STATUS_CANCELED";
    ShippingListStatusEnum["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    ShippingListStatusEnum["STATUS_INIT"] = "STATUS_INIT";
    ShippingListStatusEnum["STATUS_PENDING_CONFIRMATION"] = "STATUS_PENDING_CONFIRMATION";
    ShippingListStatusEnum["STATUS_REFUNDED"] = "STATUS_REFUNDED";
    ShippingListStatusEnum["STATUS_SUBMITTED"] = "STATUS_SUBMITTED";
    ShippingListStatusEnum["STATUS_TRANSPORT"] = "STATUS_TRANSPORT";
    ShippingListStatusEnum["STATUS_UNDELIVERED"] = "STATUS_UNDELIVERED";
    ShippingListStatusEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    ShippingListStatusEnum["STATUS_WAITING_FOR_ORDERING"] = "STATUS_WAITING_FOR_ORDERING";
    return ShippingListStatusEnum;
  }({});
  _BackendEnums.ShippingListStatusEnum = ShippingListStatusEnum;
  let ShippingShippingListListShippingProviderEnum = /*#__PURE__*/function (ShippingShippingListListShippingProviderEnum) {
    ShippingShippingListListShippingProviderEnum["CUSTOM"] = "CUSTOM";
    ShippingShippingListListShippingProviderEnum["DHL24_DROP_OFF"] = "DHL24_DROP_OFF";
    ShippingShippingListListShippingProviderEnum["DHL24_PICKUP"] = "DHL24_PICKUP";
    ShippingShippingListListShippingProviderEnum["DHL_FREIGHT_PICKUP"] = "DHL_FREIGHT_PICKUP";
    ShippingShippingListListShippingProviderEnum["DHL_INTERNATIONAL_DROPOFF"] = "DHL_INTERNATIONAL_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_BELGIUM_DROPOFF"] = "DPD_BELGIUM_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_GEO_API_DROPOFF"] = "DPD_GEO_API_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_GEO_API_PICKUP"] = "DPD_GEO_API_PICKUP";
    ShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_DROPOFF"] = "DPD_REG_PRIJEMCE_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_PICKUP"] = "DPD_REG_PRIJEMCE_PICKUP";
    ShippingShippingListListShippingProviderEnum["DPD_SK_DROPOFF"] = "DPD_SK_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_SK_PICKUP"] = "DPD_SK_PICKUP";
    ShippingShippingListListShippingProviderEnum["GEIS_PICKUP"] = "GEIS_PICKUP";
    ShippingShippingListListShippingProviderEnum["GLS_ISRS"] = "GLS_ISRS";
    ShippingShippingListListShippingProviderEnum["GLS_PICKUP"] = "GLS_PICKUP";
    ShippingShippingListListShippingProviderEnum["GLS_POLAND_API_DROPOFF"] = "GLS_POLAND_API_DROPOFF";
    ShippingShippingListListShippingProviderEnum["INPOST_DROP_OFF"] = "INPOST_DROP_OFF";
    ShippingShippingListListShippingProviderEnum["INPOST_PICKUP"] = "INPOST_PICKUP";
    ShippingShippingListListShippingProviderEnum["LIFTAGO"] = "LIFTAGO";
    ShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_CZ"] = "MY_GLS_DROP_OFF_CZ";
    ShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_HU"] = "MY_GLS_DROP_OFF_HU";
    ShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_SK"] = "MY_GLS_DROP_OFF_SK";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_CZ"] = "MY_GLS_PICKUP_CZ";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HR"] = "MY_GLS_PICKUP_HR";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HU"] = "MY_GLS_PICKUP_HU";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SI"] = "MY_GLS_PICKUP_SI";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SK"] = "MY_GLS_PICKUP_SK";
    ShippingShippingListListShippingProviderEnum["MY_PPL_CPL_DROPOFF"] = "MY_PPL_CPL_DROPOFF";
    ShippingShippingListListShippingProviderEnum["MY_PPL_CPL_PICKUP"] = "MY_PPL_CPL_PICKUP";
    ShippingShippingListListShippingProviderEnum["MY_PPL_PICKUP"] = "MY_PPL_PICKUP";
    ShippingShippingListListShippingProviderEnum["PACKETA_CLAIM_ASSISTANT"] = "PACKETA_CLAIM_ASSISTANT";
    ShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_DROPOFF"] = "PPL_RETURN_CONNECT_DROPOFF";
    ShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_PICKUP"] = "PPL_RETURN_CONNECT_PICKUP";
    ShippingShippingListListShippingProviderEnum["UPS_PICKUP"] = "UPS_PICKUP";
    return ShippingShippingListListShippingProviderEnum;
  }({});
  _BackendEnums.ShippingShippingListListShippingProviderEnum = ShippingShippingListListShippingProviderEnum;
  let TicketsListCountryEnum = /*#__PURE__*/function (TicketsListCountryEnum) {
    TicketsListCountryEnum["AE"] = "AE";
    TicketsListCountryEnum["AT"] = "AT";
    TicketsListCountryEnum["AU"] = "AU";
    TicketsListCountryEnum["BA"] = "BA";
    TicketsListCountryEnum["BE"] = "BE";
    TicketsListCountryEnum["BG"] = "BG";
    TicketsListCountryEnum["BY"] = "BY";
    TicketsListCountryEnum["CA"] = "CA";
    TicketsListCountryEnum["CH"] = "CH";
    TicketsListCountryEnum["CY"] = "CY";
    TicketsListCountryEnum["CZ"] = "CZ";
    TicketsListCountryEnum["DE"] = "DE";
    TicketsListCountryEnum["DK"] = "DK";
    TicketsListCountryEnum["EE"] = "EE";
    TicketsListCountryEnum["ES"] = "ES";
    TicketsListCountryEnum["FI"] = "FI";
    TicketsListCountryEnum["FR"] = "FR";
    TicketsListCountryEnum["GB"] = "GB";
    TicketsListCountryEnum["GL"] = "GL";
    TicketsListCountryEnum["GR"] = "GR";
    TicketsListCountryEnum["HR"] = "HR";
    TicketsListCountryEnum["HU"] = "HU";
    TicketsListCountryEnum["IE"] = "IE";
    TicketsListCountryEnum["IN"] = "IN";
    TicketsListCountryEnum["IS"] = "IS";
    TicketsListCountryEnum["IT"] = "IT";
    TicketsListCountryEnum["LI"] = "LI";
    TicketsListCountryEnum["LT"] = "LT";
    TicketsListCountryEnum["LU"] = "LU";
    TicketsListCountryEnum["LV"] = "LV";
    TicketsListCountryEnum["MC"] = "MC";
    TicketsListCountryEnum["MD"] = "MD";
    TicketsListCountryEnum["ME"] = "ME";
    TicketsListCountryEnum["MK"] = "MK";
    TicketsListCountryEnum["MT"] = "MT";
    TicketsListCountryEnum["NL"] = "NL";
    TicketsListCountryEnum["NO"] = "NO";
    TicketsListCountryEnum["PL"] = "PL";
    TicketsListCountryEnum["PT"] = "PT";
    TicketsListCountryEnum["QA"] = "QA";
    TicketsListCountryEnum["RO"] = "RO";
    TicketsListCountryEnum["RS"] = "RS";
    TicketsListCountryEnum["RU"] = "RU";
    TicketsListCountryEnum["SA"] = "SA";
    TicketsListCountryEnum["SE"] = "SE";
    TicketsListCountryEnum["SI"] = "SI";
    TicketsListCountryEnum["SK"] = "SK";
    TicketsListCountryEnum["TR"] = "TR";
    TicketsListCountryEnum["TW"] = "TW";
    TicketsListCountryEnum["UA"] = "UA";
    TicketsListCountryEnum["US"] = "US";
    TicketsListCountryEnum["VN"] = "VN";
    TicketsListCountryEnum["ZA"] = "ZA";
    return TicketsListCountryEnum;
  }({});
  _BackendEnums.TicketsListCountryEnum = TicketsListCountryEnum;
  let TicketsListLanguageEnum = /*#__PURE__*/function (TicketsListLanguageEnum) {
    TicketsListLanguageEnum["BG"] = "bg";
    TicketsListLanguageEnum["CS"] = "cs";
    TicketsListLanguageEnum["DA"] = "da";
    TicketsListLanguageEnum["DE"] = "de";
    TicketsListLanguageEnum["DE-AT"] = "de-at";
    TicketsListLanguageEnum["DE-CH"] = "de-ch";
    TicketsListLanguageEnum["EL"] = "el";
    TicketsListLanguageEnum["EN"] = "en";
    TicketsListLanguageEnum["ES"] = "es";
    TicketsListLanguageEnum["ET"] = "et";
    TicketsListLanguageEnum["FI"] = "fi";
    TicketsListLanguageEnum["FR"] = "fr";
    TicketsListLanguageEnum["FR-BE"] = "fr-be";
    TicketsListLanguageEnum["FR-CH"] = "fr-ch";
    TicketsListLanguageEnum["HR"] = "hr";
    TicketsListLanguageEnum["HU"] = "hu";
    TicketsListLanguageEnum["IT"] = "it";
    TicketsListLanguageEnum["IT-CH"] = "it-ch";
    TicketsListLanguageEnum["LT"] = "lt";
    TicketsListLanguageEnum["LV"] = "lv";
    TicketsListLanguageEnum["NB"] = "nb";
    TicketsListLanguageEnum["NL"] = "nl";
    TicketsListLanguageEnum["NL-BE"] = "nl-be";
    TicketsListLanguageEnum["PL"] = "pl";
    TicketsListLanguageEnum["PT"] = "pt";
    TicketsListLanguageEnum["RO"] = "ro";
    TicketsListLanguageEnum["SK"] = "sk";
    TicketsListLanguageEnum["SL"] = "sl";
    TicketsListLanguageEnum["SV"] = "sv";
    TicketsListLanguageEnum["UK"] = "uk";
    return TicketsListLanguageEnum;
  }({});
  _BackendEnums.TicketsListLanguageEnum = TicketsListLanguageEnum;
  let TicketsListOrderingEnum = /*#__PURE__*/function (TicketsListOrderingEnum) {
    TicketsListOrderingEnum["-CODE"] = "-code";
    TicketsListOrderingEnum["-CREATED_AT"] = "-created_at";
    TicketsListOrderingEnum["-CUSTOMER_NAME"] = "-customer_name";
    TicketsListOrderingEnum["CODE"] = "code";
    TicketsListOrderingEnum["CREATED_AT"] = "created_at";
    TicketsListOrderingEnum["CUSTOMER_NAME"] = "customer_name";
    return TicketsListOrderingEnum;
  }({});
  _BackendEnums.TicketsListOrderingEnum = TicketsListOrderingEnum;
  let TicketsListShippingStatusEnum = /*#__PURE__*/function (TicketsListShippingStatusEnum) {
    TicketsListShippingStatusEnum["CANCELED"] = "CANCELED";
    TicketsListShippingStatusEnum["CONFIRMATION_REQUIRED"] = "CONFIRMATION_REQUIRED";
    TicketsListShippingStatusEnum["DECLINED"] = "DECLINED";
    TicketsListShippingStatusEnum["FAILURE"] = "FAILURE";
    TicketsListShippingStatusEnum["FINISHED"] = "FINISHED";
    TicketsListShippingStatusEnum["REFUNDED"] = "REFUNDED";
    TicketsListShippingStatusEnum["SYNCING"] = "SYNCING";
    TicketsListShippingStatusEnum["VOIDED"] = "VOIDED";
    TicketsListShippingStatusEnum["WAITING"] = "WAITING";
    return TicketsListShippingStatusEnum;
  }({});
  _BackendEnums.TicketsListShippingStatusEnum = TicketsListShippingStatusEnum;
  let TicketsHistoryListTypeEnum = /*#__PURE__*/function (TicketsHistoryListTypeEnum) {
    TicketsHistoryListTypeEnum["ACTIVITY"] = "ACTIVITY";
    TicketsHistoryListTypeEnum["ALL"] = "ALL";
    TicketsHistoryListTypeEnum["DOCUMENT"] = "DOCUMENT";
    TicketsHistoryListTypeEnum["INTERNAL_NOTE"] = "INTERNAL_NOTE";
    TicketsHistoryListTypeEnum["MESSAGES"] = "MESSAGES";
    TicketsHistoryListTypeEnum["REFUND_REQUEST"] = "REFUND_REQUEST";
    TicketsHistoryListTypeEnum["RETINO_SHIPPING"] = "RETINO_SHIPPING";
    TicketsHistoryListTypeEnum["SMS_MESSAGES"] = "SMS_MESSAGES";
    TicketsHistoryListTypeEnum["SYSTEM"] = "SYSTEM";
    return TicketsHistoryListTypeEnum;
  }({});
  _BackendEnums.TicketsHistoryListTypeEnum = TicketsHistoryListTypeEnum;
  let TriggerLogsListStateEnum = /*#__PURE__*/function (TriggerLogsListStateEnum) {
    TriggerLogsListStateEnum["CAN_RETRY"] = "CAN_RETRY";
    TriggerLogsListStateEnum["FAILED"] = "FAILED";
    TriggerLogsListStateEnum["SUCCESS"] = "SUCCESS";
    return TriggerLogsListStateEnum;
  }({});
  _BackendEnums.TriggerLogsListStateEnum = TriggerLogsListStateEnum;
})(BackendEnums || (BackendEnums = {}));

/***/ }),

/***/ 96433:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* reexport safe */ _enums__WEBPACK_IMPORTED_MODULE_0__.f)
/* harmony export */ });
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9919);


/***/ }),

/***/ 34678:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);


const EllipsisButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_ref, ref) => {
  let {
    onClick,
    size
  } = _ref;
  const classArray = ['inline-flex', 'cursor-pointer', 'border', 'border-transparent', 'hover:border-gray-200', 'hover:bg-white', 'hover:shadow-sm', 'transition-all', 'text-sm'];
  let roundingSize = '';
  switch (size) {
    case 'tiny':
      classArray.push('px-2.5', 'py-1.5', 'text-xs');
      break;
    case 'small':
      roundingSize = '-md';
      classArray.push('px-3', 'py-2.5', 'text-sm');
      break;
    default:
    case 'medium':
      roundingSize = '-md';
      classArray.push('px-4', 'py-2.5', 'text-sm');
      break;
    case 'large':
      roundingSize = '-md';
      classArray.push('px-4', 'py-2.5', 'text-base');
      break;
    case 'huge':
      roundingSize = '-md';
      classArray.push('px-6', 'py-3.5', 'text-base');
      break;
  }
  classArray.push("rounded".concat(roundingSize));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    ref: ref,
    type: "button",
    className: classArray.join(' '),
    onClick: onClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    fitted: true,
    name: "dots-horizontal",
    className: "w-4 text-gray-600 hover:text-gray-700"
  }));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EllipsisButton);

/***/ }),

/***/ 90424:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ components_RatingEmoji)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
;// ./react/components/RatingEmoji/img/emoji_negative.svg
/* harmony default export */ const emoji_negative = ("https://cdn.retino.com/dist/files/react/components/RatingEmoji/img/emoji_negative.svg");
;// ./react/components/RatingEmoji/img/emoji_neutral.svg
/* harmony default export */ const emoji_neutral = ("https://cdn.retino.com/dist/files/react/components/RatingEmoji/img/emoji_neutral.svg");
;// ./react/components/RatingEmoji/img/emoji_positive.svg
/* harmony default export */ const emoji_positive = ("https://cdn.retino.com/dist/files/react/components/RatingEmoji/img/emoji_positive.svg");
;// ./react/components/RatingEmoji/index.tsx
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




function RatingEmoji(_ref) {
  let {
    rating,
    size = 'big'
  } = _ref;
  let imgSize = '45px';
  const baseStyles = {
    verticalAlign: 'middle'
  };
  switch (size) {
    case 'massive':
      imgSize = '101px';
      break;
    case 'large':
      imgSize = '40px';
      break;
    case 'small':
      imgSize = '25px';
      break;
    default:
      break;
  }
  switch (rating) {
    case 0:
      return /*#__PURE__*/react.createElement("img", {
        src: emoji_negative,
        alt: gettext('Bad'),
        style: _objectSpread({
          height: imgSize,
          width: imgSize,
          maxWidth: imgSize
        }, baseStyles)
      });
    case 1:
      return /*#__PURE__*/react.createElement("img", {
        src: emoji_neutral,
        alt: gettext('Good, but...'),
        style: _objectSpread({
          height: imgSize,
          width: imgSize,
          maxWidth: imgSize
        }, baseStyles)
      });
    case 2:
      return /*#__PURE__*/react.createElement("img", {
        src: emoji_positive,
        alt: gettext('Perfect'),
        style: _objectSpread({
          height: imgSize,
          width: imgSize,
          maxWidth: imgSize
        }, baseStyles)
      });
    default:
      return null;
  }
}
/* harmony default export */ const components_RatingEmoji = (RatingEmoji);

/***/ }),

/***/ 85136:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var components_thumbnails_Thumbnails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59914);
/* harmony import */ var public_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67211);



function FileUploadFieldValueWrapper(_ref) {
  let {
    value
  } = _ref;
  const [fileUploads, setFileUploads] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  const api = (0,public_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const fetchFileUploads = async () => {
      const response = await Promise.all(value.map(fileId => api.FilesFilesApi.retrieve({
        id: fileId
      })));
      return response;
    };
    if (value) {
      (async () => {
        const fetchedFileUploads = await fetchFileUploads();
        setFileUploads(fetchedFileUploads);
      })();
    }
  }, [api.FilesFilesApi, value]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(components_thumbnails_Thumbnails__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A, {
    fileUploads: fileUploads
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FileUploadFieldValueWrapper);

/***/ }),

/***/ 59914:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ thumbnails_Thumbnails)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/react-image-gallery/build/image-gallery.js
var image_gallery = __webpack_require__(78074);
var image_gallery_default = /*#__PURE__*/__webpack_require__.n(image_gallery);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var utils = __webpack_require__(36315);
// EXTERNAL MODULE: ./react/ui/index.ts + 2 modules
var ui = __webpack_require__(61715);
;// ./react/components/thumbnails/IconThumbnail.tsx


function IconThumbnail(_ref) {
  let {
    filename
  } = _ref;
  const regexIcon = [[/(.*\.pdf)/, 'document-text'], [/(.*\.mp3|.*\.wav)/, 'volume-up'], [/(.*\.mp4|.*\.avi|.*\.mov)/, 'video-camera'], [/(.*\.txt)/, 'document-text'], [/(.*\.html)/, 'document-text'], [/(.*\.docx)/, 'document-text'], [/(.*\.jpeg|.*\.jpg|.*\.png|.*\.gif|.*\.svg)/, 'photograph'], [/(.*\.zip|.*\.rar|.*\.tar)/, 'folder-download']];
  const icons = regexIcon.map(_ref2 => {
    let [regex, icon] = _ref2;
    return filename.match(regex) ? icon : undefined;
  }).filter(icon => icon !== undefined);
  const icon = icons.length ? icons[0] : 'file outline';
  return /*#__PURE__*/react.createElement("div", {
    className: "flex h-full items-center justify-center"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    fitted: true,
    name: icon,
    size: "huge"
  }));
}
/* harmony default export */ const thumbnails_IconThumbnail = (IconThumbnail);
// EXTERNAL MODULE: ./react/components/PaddedLoader.tsx
var PaddedLoader = __webpack_require__(61484);
;// ./react/components/thumbnails/ImageThumbnail.tsx



function ImageThumbnail(_ref) {
  let {
    filename,
    url,
    thumbnailUrl,
    disablePreview = false
  } = _ref;
  const [backgroundImage, setBackgroundImage] = (0,react.useState)(undefined);
  const [isLoading, setIsLoading] = (0,react.useState)(true);
  const loadImage = () => {
    setIsLoading(true);
    const img = new Image();
    img.src = thumbnailUrl;
    img.onload = () => {
      setBackgroundImage(thumbnailUrl);
      setIsLoading(false);
    };
    img.onerror = () => {
      setIsLoading(false);
    };
  };
  (0,react.useEffect)(() => {
    loadImage();
  }, []);
  if (isLoading) {
    return /*#__PURE__*/react.createElement("div", {
      style: {
        width: '100%',
        height: '100%'
      }
    }, /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null));
  }
  return /*#__PURE__*/react.createElement("div", {
    className: !disablePreview ? 'cursor-pointer' : undefined,
    style: {
      width: '100%',
      height: '100%'
    },
    role: "presentation"
  }, backgroundImage ? /*#__PURE__*/react.createElement("div", {
    style: {
      borderRadius: 3,
      width: '100%',
      height: '100%',
      background: "url(".concat(backgroundImage, ")"),
      backgroundPosition: 'center center',
      backgroundSize: 'cover'
    }
  }) : /*#__PURE__*/react.createElement("span", {
    className: "anchor"
  }, /*#__PURE__*/react.createElement(thumbnails_IconThumbnail, {
    filename: filename,
    url: url
  })));
}
/* harmony default export */ const thumbnails_ImageThumbnail = (ImageThumbnail);
;// ./react/components/thumbnails/Thumbnail.tsx




function Thumbnail(_ref) {
  let {
    fileUpload,
    disablePreview = false,
    onClick = () => {}
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex h-full w-full items-center justify-center",
    onClick: onClick,
    role: "presentation"
  }, (0,utils/* isImage */.wu)(fileUpload.filename) ? /*#__PURE__*/react.createElement(thumbnails_ImageThumbnail, {
    disablePreview: disablePreview,
    filename: fileUpload.filename,
    url: fileUpload.file,
    thumbnailUrl: "".concat(fileUpload.file, "__320x320.png")
  }) : /*#__PURE__*/react.createElement("a", {
    href: fileUpload.file,
    download: fileUpload.filename,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      display: 'block',
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/react.createElement(thumbnails_IconThumbnail, {
    filename: fileUpload.filename,
    url: fileUpload.file
  })));
}
/* harmony default export */ const thumbnails_Thumbnail = (Thumbnail);
;// ./react/components/thumbnails/ThumbnailsWrapper.tsx
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function ThumbnailsWrapper(_ref) {
  let {
    children,
    style
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "grid w-64 max-w-full grid-cols-3 gap-1 md:w-96 md:grid-cols-5",
    style: _objectSpread({}, style)
  }, children.map((child, index) => /*#__PURE__*/react.createElement("div", {
    key: index,
    className: "relative flex items-center justify-center rounded border border-gray-200 bg-white p-1"
  }, /*#__PURE__*/react.createElement("div", {
    style: {
      paddingBottom: '100%'
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "absolute top-0 bottom-0 left-0 right-0"
  }, child))));
}
/* harmony default export */ const thumbnails_ThumbnailsWrapper = (ThumbnailsWrapper);
;// ./react/components/thumbnails/Thumbnails.tsx







function GalleryNavButton(_ref) {
  let {
    icon,
    onClick,
    disabled,
    direction
  } = _ref;
  const classArray = ['inline-flex', 'items-center', 'font-medium', 'whitespace-nowrap', 'text-base', 'image-gallery-icon', "image-gallery-".concat(direction, "-nav"), 'hover:text-indigo-500'];
  const iconClassArray = ['h-16', 'w-16', 'px-1.5', 'py-2.5'];
  if (disabled) {
    classArray.push('opacity-50', 'cursor-not-allowed');
  }
  return /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: classArray.join(' '),
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: icon,
    size: "huge",
    className: iconClassArray.join(' ')
  }));
}
function Thumbnails(_ref2) {
  let {
    fileUploads,
    disablePreview = false
  } = _ref2;
  const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
  const [selectedIdx, setSelectedIdx] = (0,react.useState)(0);

  // used gallery library - https://github.com/xiaolin/react-image-gallery
  const galleryRef = (0,react.useCallback)(galleryNode => {
    if (galleryNode) {
      galleryNode.slideToIndex(selectedIdx);
    }
  }, [selectedIdx]);
  const imageFileUploads = fileUploads.filter(fileUpload => (0,utils/* isImage */.wu)(fileUpload.filename));
  const handleFileUploadClick = fileUpload => {
    const fileUploadIdx = imageFileUploads.findIndex(item => item.id === fileUpload.id);
    if (fileUploadIdx !== -1) {
      setIsModalOpen(true);
      setSelectedIdx(fileUploadIdx);
    }
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(thumbnails_ThumbnailsWrapper, null, fileUploads.map(item => /*#__PURE__*/react.createElement(thumbnails_Thumbnail, {
    key: item.id,
    disablePreview: disablePreview,
    fileUpload: item,
    onClick: () => handleFileUploadClick(item)
  }))), /*#__PURE__*/react.createElement(ui/* Modal */.aF, {
    open: isModalOpen,
    onClose: () => setIsModalOpen(false),
    size: "7xl"
  }, /*#__PURE__*/react.createElement("div", {
    className: "react-image-gallery-wrapper rounded-lg bg-gray-200 px-4 pt-4"
  }, /*#__PURE__*/react.createElement((image_gallery_default()), {
    ref: galleryRef,
    items: imageFileUploads.map(fileUpload => ({
      original: fileUpload.file,
      thumbnail: "".concat(fileUpload.file),
      originalTitle: fileUpload.filename,
      originalAlt: fileUpload.filename,
      thumbnailTitle: fileUpload.filename,
      thumbnailAlt: fileUpload.filename
    })),
    showPlayButton: false,
    showFullscreenButton: false,
    infinite: false,
    renderLeftNav: (onClick, disabled) => /*#__PURE__*/react.createElement(GalleryNavButton, {
      icon: "arrow-left",
      onClick: onClick,
      disabled: disabled,
      direction: "left"
    }),
    renderRightNav: (onClick, disabled) => /*#__PURE__*/react.createElement(GalleryNavButton, {
      icon: "arrow-right",
      onClick: onClick,
      disabled: disabled,
      direction: "right"
    })
  }))));
}
/* harmony default export */ const thumbnails_Thumbnails = (Thumbnails);

/***/ }),

/***/ 46661:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function LogoIcon() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    viewBox: "0 0 279 70",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.215 68.3582V20.5255H166.863V68.3582H152.215ZM159.539 16.0949C157.309 16.0949 155.41 15.3113 153.843 13.744C152.275 12.1767 151.492 10.2778 151.492 8.04746C151.492 5.81708 152.275 3.91824 153.843 2.35095C155.41 0.783649 157.309 0 159.539 0C161.77 0 163.668 0.783649 165.236 2.35095C166.803 3.91824 167.587 5.81708 167.587 8.04746C167.587 10.2778 166.803 12.1767 165.236 13.744C163.668 15.3113 161.77 16.0949 159.539 16.0949ZM0 68.3582V5.06357H32.3707C36.7109 5.06357 40.5689 5.93764 43.9446 7.68578C47.3203 9.37364 49.9425 11.7547 51.8112 14.829C53.7402 17.8431 54.7047 21.3092 54.7047 25.2274C54.7047 29.206 53.6196 32.7625 51.4495 35.8971C49.2794 39.0317 46.4161 41.4128 42.8595 43.0404L56.6939 68.3582H39.3331L27.3975 45.3009H15.5524V68.3582H0ZM15.5524 32.642H30.924C33.3352 32.642 35.2642 31.9789 36.7109 30.6527C38.2179 29.3265 38.9714 27.6085 38.9714 25.4987C38.9714 23.3889 38.2179 21.6709 36.7109 20.3447C35.2642 19.0185 33.3352 18.3554 30.924 18.3554H15.5524V32.642ZM83.1046 69.2624C78.2219 69.2624 73.7912 68.1774 69.8127 66.0073C65.8945 63.7769 62.79 60.793 60.4994 57.0556C58.2087 53.3182 57.0634 49.1287 57.0634 44.4871C57.0634 39.8455 58.1484 35.656 60.3185 31.9186C62.5489 28.1812 65.5629 25.2274 69.3606 23.0573C73.1583 20.827 77.3779 19.7118 82.0195 19.7118C86.7214 19.7118 90.8808 20.8571 94.4976 23.1478C98.1145 25.3781 100.948 28.4524 102.997 32.3707C105.107 36.2889 106.162 40.7798 106.162 45.8434V49.4602H72.0732C72.7363 50.9673 73.6104 52.2934 74.6954 53.4388C75.8408 54.5841 77.1971 55.4883 78.7644 56.1514C80.3317 56.7542 82.0195 57.0556 83.828 57.0556C85.8172 57.0556 87.6256 56.7542 89.2532 56.1514C90.8808 55.4883 92.2672 54.5841 93.4126 53.4388L103.088 62.0288C100.074 64.5605 96.9691 66.3991 93.7743 67.5444C90.6397 68.6898 87.0831 69.2624 83.1046 69.2624ZM71.802 39.2427H91.785C91.3027 37.6754 90.5493 36.3492 89.5245 35.2642C88.56 34.1188 87.4146 33.2448 86.0885 32.642C84.7623 31.9789 83.3156 31.6473 81.7483 31.6473C80.1207 31.6473 78.6438 31.9487 77.3177 32.5515C75.9915 33.1543 74.8462 34.0284 73.8817 35.1737C72.9775 36.2588 72.2842 37.6151 71.802 39.2427ZM122.806 65.1935C125.76 67.7253 130.1 68.9912 135.827 68.9912C137.214 68.9912 138.932 68.8405 140.981 68.5391C143.031 68.2979 144.718 67.9664 146.045 67.5444V55.6993C144.839 56.061 143.724 56.3322 142.699 56.5131C141.735 56.6336 140.649 56.6939 139.444 56.6939C137.093 56.6939 135.435 56.2719 134.471 55.428C133.567 54.5238 133.114 53.0168 133.114 50.907V32.7324H146.497V20.5255H133.114V5.06357L118.466 8.2283V20.5255H108.791V32.7324H118.466V53.9004C118.466 58.8037 119.913 62.6014 122.806 65.1935ZM175.88 20.5255V68.3582H190.528V35.9875C191.553 34.7819 192.759 33.8476 194.145 33.1845C195.592 32.5214 197.249 32.1898 199.118 32.1898C201.77 32.1898 203.88 32.9735 205.448 34.5408C207.015 36.1081 207.799 38.2179 207.799 40.8703V68.3582H222.447V52.411L214.655 43.849C212.222 41.1745 214.119 36.8822 217.735 36.8822H222.368C222.129 33.8984 221.341 31.219 220.005 28.8443C218.378 25.9508 216.117 23.6903 213.224 22.0627C210.391 20.4351 207.105 19.6213 203.368 19.6213C198.425 19.6213 194.145 21.0078 190.528 23.7807V20.5255H175.88Z",
    fill: "currentColor"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.016 32.1224C248.472 32.1224 243.814 35.914 242.493 41.0455L253.381 41.0455L235.608 60.6764L217.834 41.0455L229.206 41.0455C230.677 28.6489 241.224 19.0352 254.016 19.0352C267.814 19.0352 279 30.2212 279 44.0199C279 57.8186 267.814 69.0046 254.016 69.0046C248.402 69.0046 243.221 67.1534 239.05 64.0281L247.915 54.2363C249.699 55.3038 251.786 55.9174 254.016 55.9174C260.587 55.9174 265.913 50.5907 265.913 44.0199C265.913 41.3668 265.045 38.9166 263.577 36.9379L263.628 36.8814H263.535C261.364 33.9916 257.908 32.1224 254.016 32.1224Z",
    fill: "currentColor"
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoIcon);

/***/ }),

/***/ 55783:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var components_form_controls_FileUploadFieldValueWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85136);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36315);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61715);
/* provided dependency */ var moment = __webpack_require__(95093);




function ProductCustomFieldValueRender(_ref) {
  var _customField$options;
  let {
    value,
    customField
  } = _ref;
  switch (customField.type) {
    case 'SELECT':
      return (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .currentLanguage */ .aS)(((_customField$options = customField.options) === null || _customField$options === void 0 ? void 0 : _customField$options.find(o => o.id === value)) && customField.options.find(o => o.id === value).label) || '–';
    case 'DATE':
      return value ? moment(value).format('LL') : '–';
    case 'CHAR':
      return value || '–';
    case 'MULTILINE':
      return value ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .nl2br */ .HA)(String(value))) : '–';
    case 'LINK':
      return value && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: value.url,
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .$n, {
        link: true
      }, value.text)) || '–';
    case 'FILE':
      return value && value.length > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(components_form_controls_FileUploadFieldValueWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A, {
        value: value
      }) : '–';
    default:
      return null;
  }
}
function ProductCustomFieldValue(_ref2) {
  let {
    customFields,
    customField
  } = _ref2;
  const value = customFields[customField.id];
  if (customField.is_internal && !value) {
    return null;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .NamedProperty */ .pF, {
    name: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .currentLanguage */ .aS)(customField.name),
    value: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductCustomFieldValueRender, {
      customField: customField,
      value: value
    })
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCustomFieldValue);

/***/ }),

/***/ 19142:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _FeedEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37008);


function Feed(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "feed flow-root"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, children));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Feed, {
  Event: _FeedEvent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A
}));

/***/ })

}]);